export const STR_FORMS: any[] = [
    {
        "columns": [{
            "name": "productStoreId",
            "title": "Store ID"
        }, {
            "name": "storeName",
            "title": "Store Name"
        }, {
            "name": "title",
            "title": "Title"
        }, {
            "name": "subtitle",
            "title": "Sub-Title"
        }],
        "formName": "ListProductStore",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "image": "",
            "fieldHelpText": "",
            "alternate": "",
            "description": "",
            "type": "HYPERLINK",
            "target": "EditProductStore",
            "isSortField": "Y",
            "width": "",
            "name": "productStoreId",
            "parameterList": [{
                "name": "productStoreId"
            }],
            "style": "",
            "id": "ListProductStore_productStoreId",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "event": "edit",
            "formData": {
                "formName": "EditProductStore",
                "formLocation": "component://kwikstore/widget/StoreForms.xml",
                "link": "admin/stores/store/${productStoreId}"
            },
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "isSortField": "Y",
            "size": 0,
            "name": "storeName",
            "description": "",
            "style": "",
            "id": "ListProductStore_storeName",
            "type": "DISPLAY",
            "title": "",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "isSortField": "Y",
            "size": 0,
            "name": "title",
            "description": "",
            "style": "",
            "id": "ListProductStore_title",
            "type": "DISPLAY",
            "title": "",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "isSortField": "Y",
            "size": 0,
            "name": "subtitle",
            "description": "",
            "style": "",
            "id": "ListProductStore_subtitle",
            "type": "DISPLAY",
            "title": "",
            "imageLocation": ""
        }],
        "target": ""
    },
    {
        "fieldSets": [{
            "fieldSetName": "Default",
            "fields": ["productStoreId", "primaryStoreGroupId", "storeName", "title", "subtitle", "companyName", "isDemoStore", "ecomThemeId", "inventoryFacilityId"]
        }, {
            "fieldSetName": "Inventory",
            "fields": ["oneInventoryFacility", "isImmediatelyFulfilled", "checkInventory", "requireInventory", "requirementMethodEnumId", "reserveInventory", "reserveOrderEnumId", "balanceResOnOrderCreation", "showOutOfStockProducts", "managedByLot", "viewCartOnAdd"]
        }, {
            "fieldSetName": "ShoppingCart",
            "fields": ["autoSaveCart", "addToCartReplaceUpsell", "addToCartRemoveIncompat", "showCheckoutGiftOptions", "prodSearchExcludeVariants", "orderDecimalQuantity", "prorateShipping"]
        }, {
            "fieldSetName": "Shipping",
            "fields": ["reqShipAddrForDigItems", "selectPaymentTypePerItem", "shipIfCaptureFails", "splitPayPrefPerShpGrp", "payToPartyId"]
        }, {
            "fieldSetName": "Payments",
            "fields": ["storeCreditAccountEnumId", "manualAuthIsCapture", "retryFailedAuths", "daysToCancelNonPay", "autoOrderCcTryExp", "autoOrderCcTryOtherCards", "autoOrderCcTryLaterNsf", "autoOrderCcTryLaterMax", "storeCreditValidDays", "setOwnerUponIssuance", "orderNumberPrefix"]
        }, {
            "fieldSetName": "Orders",
            "fields": ["defaultSalesChannelEnumId", "explodeOrderItems", "checkGcBalance", "autoInvoiceDigitalItems", "autoApproveInvoice", "autoApproveOrder", "reqReturnInventoryReceive", "defaultLocaleString"]
        }, {
            "fieldSetName": "Localization",
            "fields": ["defaultCurrencyUomId", "defaultTimeZoneString", "headerApprovedStatus"]
        }, {
            "fieldSetName": "Orders Status",
            "fields": ["itemApprovedStatus", "digitalItemApprovedStatus", "headerDeclinedStatus", "itemDeclinedStatus", "headerCancelStatus", "itemCancelStatus", "authDeclinedMessage"]
        }, {
            "fieldSetName": "Messages",
            "fields": ["authFraudMessage", "authErrorMessage", "prorateTaxes"]
        }, {
            "fieldSetName": "Tax",
            "fields": ["showPricesWithVatTax", "showTaxIsExempt", "vatTaxAuthGeoId", "vatTaxAuthPartyId", "autoApproveReviews"]
        }, {
            "fieldSetName": "Visitors",
            "fields": ["allowPassword", "defaultPassword", "usePrimaryEmailUsername", "requireCustomerRole", "enableAutoSuggestionList", "enableDigProdUpload"]
        }, {
            "fieldSetName": "Upload",
            "fields": ["digProdUploadCategoryId", "allowComment", "allocateInventory", "inventoryFacilityLink", "oldStyleSheet", "oldHeaderLogo", "oldHeaderMiddleBackground", "oldHeaderRightBackground", "submitButton"]
        }],
        "formName": "EditProductStore",
        "targets": {
            "createTarget": "createProductStore",
            "updateTarget": "updateProductStore"
        },
        "altTarget": [{
            "useWhen": "productStore==null",
            "targetExdr": {
                "chars": "createProductStore",
                "hint": 20,
                "empty": false,
                "original": "createProductStore"
            }
        }],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "oldStyleSheet",
            "action": "",
            "id": "EditProductStore_oldStyleSheet",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "oldHeaderLogo",
            "action": "",
            "id": "EditProductStore_oldHeaderLogo",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "oldHeaderMiddleBackground",
            "action": "",
            "id": "EditProductStore_oldHeaderMiddleBackground",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "oldHeaderRightBackground",
            "action": "",
            "id": "EditProductStore_oldHeaderRightBackground",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "": "",
            "fieldHelpText": "The id for the product store.",
            "textSize": "20",
            "ajaxUrl": "",
            "maxlength": "20",
            "tabindex": "",
            "className": "required",
            "title": "Product Store ID",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "productStoreId",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_productStoreId",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Primary Store Group ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Not Applicable [_NA_]",
                "key": "_NA_"
            }],
            "disabled": "false",
            "id": "EditProductStore_primaryStoreGroupId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "What group this store belongs to. Stores can be grouped together with a price for each store group. It can be left blank if there are no store groups set up.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "primaryStoreGroupId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "This is the name of the store that this catalog represents.",
            "textSize": "30",
            "ajaxUrl": "",
            "maxlength": "100",
            "tabindex": "",
            "className": "required",
            "title": "Store Name",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "storeName",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_storeName",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "This value gets displayed in the header section of the ecommerce store.",
            "textSize": "30",
            "ajaxUrl": "",
            "maxlength": "100",
            "tabindex": "",
            "className": "",
            "title": "Title",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "title",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_title",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "This value gets displayed in the header section of the ecommerce store.",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Sub-Title",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "subtitle",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_subtitle",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "This is the name of the company that this catalog represents.",
            "textSize": "40",
            "ajaxUrl": "",
            "maxlength": "60",
            "tabindex": "",
            "className": "",
            "title": "Company Name",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "companyName",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_companyName",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Is Demo Store",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_isDemoStore",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If Yes, any orders created will not be sent, credit card charges will not be made, etc.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "isDemoStore",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "For controlling the look and feel of the web-based store.",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "EC_DEFAULT - OFBiz Ecommerce Standard Floating Layout",
                "key": "EC_DEFAULT"
            }, {
                "description": "MULTIFLEX - Alternative VisualTheme for Ecommerce",
                "key": "MULTIFLEX"
            }],
            "disabled": "false",
            "id": "EditProductStore_ecomThemeId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "ecomThemeId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Inventory Facility ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "My Retail Store [MyRetailStore]",
                "key": "MyRetailStore"
            }, {
                "description": "Regional Warehouse1 [RegionalWarehouse1]",
                "key": "RegionalWarehouse1"
            }, {
                "description": "Regional Warehouse2 [RegionalWarehouse2]",
                "key": "RegionalWarehouse2"
            }, {
                "description": "Store Warehouse1 [StoreWarehouse1]",
                "key": "StoreWarehouse1"
            }, {
                "description": "Store Warehouse2 [StoreWarehouse2]",
                "key": "StoreWarehouse2"
            }, {
                "description": "Web Store Warehouse [WebStoreWarehouse]",
                "key": "WebStoreWarehouse"
            }],
            "disabled": "false",
            "id": "EditProductStore_inventoryFacilityId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "This is where the stock levels are drawn from.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "inventoryFacilityId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "One Inventory Facility",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_oneInventoryFacility",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If this is a 'Single Inventory' facility. With newer or less complex businesses, you will find the Single Inventory concept much easier to work with.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "oneInventoryFacility",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Is Immediately Fulfilled",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_isImmediatelyFulfilled",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If Yes, the order will be immediately fulfilled through system-generated processes in ofbiz.  If no, it will be held for manual review.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "isImmediatelyFulfilled",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Check Inventory",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_checkInventory",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "This determines whether the system checks inventory levels when processing an order.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "checkInventory",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Require Inventory",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_requireInventory",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If sufficient inventory not on hand, order will not be processed when this flag is set to Yes.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "requireInventory",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Requirement Method Enum ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "No Requirement Created",
                "key": "PRODRQM_NONE"
            }, {
                "description": "Automatic For Every Sales Order",
                "key": "PRODRQM_AUTO"
            }, {
                "description": "When QOH Reaches Minimum Stock for Product-Facility",
                "key": "PRODRQM_STOCK"
            }, {
                "description": "When ATP Reaches Minimum Stock for Product-Facility",
                "key": "PRODRQM_STOCK_ATP"
            }, {
                "description": "Requirement for order when ATP Reaches Minimum Stock for Product-Facility",
                "key": "PRODRQM_ATP"
            }, {
                "description": "Drop-ship only",
                "key": "PRODRQM_DS"
            }, {
                "description": "Auto drop-ship on low quantity",
                "key": "PRODRQM_DSATP"
            }],
            "disabled": "false",
            "id": "EditProductStore_requirementMethodEnumId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Refers to warehouse stocking level triggers.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "requirementMethodEnumId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Reserve Inventory",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_reserveInventory",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Causes inventory to be reserved for items ordered in the store. The inventory may still be on hand but will no longer be available for other orders.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "reserveInventory",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Reserve Order Enum ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "FIFO Expire",
                "key": "INVRO_FIFO_EXP"
            }, {
                "description": "FIFO Received",
                "key": "INVRO_FIFO_REC"
            }, {
                "description": "Greater Unit Cost",
                "key": "INVRO_GUNIT_COST"
            }, {
                "description": "LIFO Expire",
                "key": "INVRO_LIFO_EXP"
            }, {
                "description": "LIFO Received",
                "key": "INVRO_LIFO_REC"
            }, {
                "description": "Less Unit Cost",
                "key": "INVRO_LUNIT_COST"
            }],
            "disabled": "false",
            "id": "EditProductStore_reserveOrderEnumId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Choose how inventory should be reserved.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "reserveOrderEnumId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Balance Res On Order Creation",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_balanceResOnOrderCreation",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If set to Y, when a new sales order is created with backordered items, then reservations on the facility/product are reassigned according to the priority given by the shipBeforeDate field.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "balanceResOnOrderCreation",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Show Out Of Stock Products",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_showOutOfStockProducts",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If N then out of stock products will not be displayed on site",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "showOutOfStockProducts",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Lots managing",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_managedByLot",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "managedByLot",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "View Cart On Add",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_viewCartOnAdd",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Controls whether the user is taken to the shopping cart immediately after adding a product to his cart.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "viewCartOnAdd",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Auto Save Cart",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_autoSaveCart",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Drop-down Y/N box on the question of automatically saving the contents of the shopping cart.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "autoSaveCart",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Add To Cart Replace Upsell",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_addToCartReplaceUpsell",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If Y then on add to cart remove all products in cart with a ProductAssoc record related from the product and with the PRODUCT_UPGRADE type.",
            "dDFCurrent": "first-in-list",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "addToCartReplaceUpsell",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Add To Cart Remove Incompat",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_addToCartRemoveIncompat",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If Y then on add to cart remove all products in cart with a ProductAssoc record related to or from the product and with the PRODUCT_INCOMPATABLE type.",
            "dDFCurrent": "first-in-list",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "addToCartRemoveIncompat",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Show Checkout Gift Options",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_showCheckoutGiftOptions",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If set to N the options related to gifts (the 'is gift' and 'gift message' options) will not be shown during checkout.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "showCheckoutGiftOptions",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Prod Search Exclude Variants",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_prodSearchExcludeVariants",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If set to Y an additional constraint will of isVariant!=Y will be added to all product searches for the store.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "prodSearchExcludeVariants",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Allow order decimal quantity",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_orderDecimalQuantity",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "orderDecimalQuantity",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Prorate Shipping",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_prorateShipping",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "When some share of the cost of shipping is covered under an account other than the bill-to.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "prorateShipping",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Req Ship Addr For Dig Items",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_reqShipAddrForDigItems",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Require Shipping Address for Digital Items? Note this only has an effect if there are ONLY digital goods in the cart.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "reqShipAddrForDigItems",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Select Payment Type Per Item",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_selectPaymentTypePerItem",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If Yes, allows customer to pay for some order items with one payment type, others with another type.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "selectPaymentTypePerItem",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Ship If Capture Fails",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_shipIfCaptureFails",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If N, the captureOrderPayments will cause a service error if credit card capture fails.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "shipIfCaptureFails",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Split Pay Pref Per Shp Grp",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_splitPayPrefPerShpGrp",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If Y then before the order is stored the OrderPaymentPreference record will be split, one for each OrderItemShipGroup.",
            "dDFCurrent": "first-in-list",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "splitPayPrefPerShpGrp",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldHelpText": "Note that this corresponds with the organizationPartyId that GL transactions will be posted to.",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStore",
                "id": "EditProductStore_payToPartyId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupPartyName",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "payToPartyId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "payToPartyId",
            "style": "",
            "id": "EditProductStore_payToPartyId",
            "title": "Pay To Party ID",
            "type": "LOOKUP"
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Store Credit Account Enum ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Financial Account",
                "key": "FIN_ACCOUNT"
            }, {
                "description": "Billing Account",
                "key": "BILLING_ACCOUNT"
            }],
            "disabled": "false",
            "id": "EditProductStore_storeCreditAccountEnumId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Specify the type (Billing Account or Financial Account) of Store Credit Account used for refund return.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "storeCreditAccountEnumId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Manual Auth Is Capture",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_manualAuthIsCapture",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Drop-down Y/N box on the question of whether a Manual Authorization is captured.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "manualAuthIsCapture",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Retry Failed Auths",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_retryFailedAuths",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "How many times can an unsuccessful attempt to authorize an order be allowed?",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "retryFailedAuths",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "Triggers cancellation of orders for non-payment after the number of days entered here.",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Days To Cancel Non Pay",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "daysToCancelNonPay",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_daysToCancelNonPay",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Auto Order Cc Try Exp",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_autoOrderCcTryExp",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "For auto-orders try other Credit Card expiration dates (if date is wrong or general failure where type not known).",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "autoOrderCcTryExp",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Auto Order Cc Try Other Cards",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_autoOrderCcTryOtherCards",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "For auto-orders try other Credit Cards for the customer.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "autoOrderCcTryOtherCards",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Auto Order Cc Try Later Nsf",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_autoOrderCcTryLaterNsf",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "For auto-orders if Credit Cards fails for NSF (Not Sufficient Funds) try again later.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "autoOrderCcTryLaterNsf",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "For auto-orders if Credit Cards fails for NSF try again how many times.",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Auto Order Cc Try Later Max",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "autoOrderCcTryLaterMax",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_autoOrderCcTryLaterMax",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "How many days that store credit is valid for. Null value implies no expiration.",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Store Credit Valid Days",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "storeCreditValidDays",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_storeCreditValidDays",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Set Owner Upon Issuance",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_setOwnerUponIssuance",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If Y or empty, set the inventory item owner upon issuance.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "setOwnerUponIssuance",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "All orders will be prefixed by this. For example, if you wished accounting to be able to quickly differentiate orders between stores.",
            "textSize": "40",
            "ajaxUrl": "",
            "maxlength": "60",
            "tabindex": "",
            "className": "",
            "title": "Order Number Prefix",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "orderNumberPrefix",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_orderNumberPrefix",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Default Sales Channel Enum ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Affiliate Channel",
                "key": "AFFIL_SALES_CHANNEL"
            }, {
                "description": "E-Mail Channel",
                "key": "EMAIL_SALES_CHANNEL"
            }, {
                "description": "Fax Channel",
                "key": "FAX_SALES_CHANNEL"
            }, {
                "description": "POS Channel",
                "key": "POS_SALES_CHANNEL"
            }, {
                "description": "Phone Channel",
                "key": "PHONE_SALES_CHANNEL"
            }, {
                "description": "Snail Mail Channel",
                "key": "SNAIL_SALES_CHANNEL"
            }, {
                "description": "Unknown Channel",
                "key": "UNKNWN_SALES_CHANNEL"
            }, {
                "description": "Web Channel",
                "key": "WEB_SALES_CHANNEL"
            }, {
                "description": "eBay Channel",
                "key": "EBAY_SALES_CHANNEL"
            }],
            "disabled": "false",
            "id": "EditProductStore_defaultSalesChannelEnumId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Unless the sales channel has been specified in the transaction, it will be assumed that the sale came in through the selected path.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "defaultSalesChannelEnumId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Explode Order Items",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_explodeOrderItems",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If set to Y then any shopping cart item with a quantity greater than one will be split into separate order items with a quantity of 1 each.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "explodeOrderItems",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Check Gc Balance",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_checkGcBalance",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Check Gc Balance",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "checkGcBalance",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Auto Invoice Digital Items",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_autoInvoiceDigitalItems",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If Y, digital items will be immediately invoiced when the order is placed.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "autoInvoiceDigitalItems",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Auto Approve Invoice",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_autoApproveInvoice",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If Y or empty, sales invoices created from orders will be marked ready.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "autoApproveInvoice",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Auto Approve Order",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_autoApproveOrder",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If N, orders will not be automatically approved when payment is authorized.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "autoApproveOrder",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Req Return Inventory Receive",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_reqReturnInventoryReceive",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If set to Y return will automatically go to the Received status when Accepted instead of waiting for actual receipt of the return.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "reqReturnInventoryReceive",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "Default locale, for language, number, and currency formats.",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "10",
            "tabindex": "",
            "className": "",
            "title": "Default Locale String",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "defaultLocaleString",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_defaultLocaleString",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Default Currency Uom ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Afghani - AFN",
                "key": "AFN"
            }, {
                "description": "Albanian Lek - ALL",
                "key": "ALL"
            }, {
                "description": "Algerian Dinar - DZD",
                "key": "DZD"
            }, {
                "description": "American Dollar - USD",
                "key": "USD"
            }, {
                "description": "Angolan Kwanza - AOA",
                "key": "AOA"
            }, {
                "description": "Argentina Peso - ARS",
                "key": "ARS"
            }, {
                "description": "Armenian Dram - AMD",
                "key": "AMD"
            }, {
                "description": "Aruban Guilder - AWG",
                "key": "AWG"
            }, {
                "description": "Australian Dollar - AUD",
                "key": "AUD"
            }, {
                "description": "Azerbaijan Manat - AZN",
                "key": "AZN"
            }, {
                "description": "Bahaman Dollar - BSD",
                "key": "BSD"
            }, {
                "description": "Bahrain Dinar - BHD",
                "key": "BHD"
            }, {
                "description": "Bangladesh Taka - BDT",
                "key": "BDT"
            }, {
                "description": "Barbados Dollar - BBD",
                "key": "BBD"
            }, {
                "description": "Belize Dollar - BZD",
                "key": "BZD"
            }, {
                "description": "Belorussian Ruble - BYN",
                "key": "BYN"
            }, {
                "description": "Benin C.f.A. Franc - XOF",
                "key": "XOF"
            }, {
                "description": "Bermudan Dollar - BMD",
                "key": "BMD"
            }, {
                "description": "Bolivian Boliviano - BOB",
                "key": "BOB"
            }, {
                "description": "Botswana Pula - BWP",
                "key": "BWP"
            }, {
                "description": "Brazilian Real - BRL",
                "key": "BRL"
            }, {
                "description": "British Pound - GBP",
                "key": "GBP"
            }, {
                "description": "Brunei Dollar - BND",
                "key": "BND"
            }, {
                "description": "Bulgarian Lev - BGN",
                "key": "BGN"
            }, {
                "description": "Burundi Franc - BIF",
                "key": "BIF"
            }, {
                "description": "Cambodian Riel - KHR",
                "key": "KHR"
            }, {
                "description": "Canadian Dollar - CAD",
                "key": "CAD"
            }, {
                "description": "Cape Verde Escudo - CVE",
                "key": "CVE"
            }, {
                "description": "Cayman Dollar - KYD",
                "key": "KYD"
            }, {
                "description": "Chilean Peso - CLP",
                "key": "CLP"
            }, {
                "description": "China - CNY",
                "key": "CNY"
            }, {
                "description": "Colombian Peso - COP",
                "key": "COP"
            }, {
                "description": "Comoros Franc - KMF",
                "key": "KMF"
            }, {
                "description": "Convertible Marks - BAM",
                "key": "BAM"
            }, {
                "description": "Costa Rica Colon - CRC",
                "key": "CRC"
            }, {
                "description": "Croatian Kuna - HRK",
                "key": "HRK"
            }, {
                "description": "Cuban Peso - CUP",
                "key": "CUP"
            }, {
                "description": "Czech Krona - CZK",
                "key": "CZK"
            }, {
                "description": "Danish Krone - DKK",
                "key": "DKK"
            }, {
                "description": "Djibouti Franc - DJF",
                "key": "DJF"
            }, {
                "description": "Dominican Peso - DOP",
                "key": "DOP"
            }, {
                "description": "East Carribean Dollar - XCD",
                "key": "XCD"
            }, {
                "description": "Egyptian Pound - EGP",
                "key": "EGP"
            }, {
                "description": "El Salvador Colon - SVC",
                "key": "SVC"
            }, {
                "description": "Ethiopian Birr - ETB",
                "key": "ETB"
            }, {
                "description": "Euro - EUR",
                "key": "EUR"
            }, {
                "description": "Falkland Pound - FKP",
                "key": "FKP"
            }, {
                "description": "Fiji Dollar - FJD",
                "key": "FJD"
            }, {
                "description": "Gabon C.f.A Franc - XAF",
                "key": "XAF"
            }, {
                "description": "Gambian Dalasi - GMD",
                "key": "GMD"
            }, {
                "description": "Ghanian Cedi - GHS",
                "key": "GHS"
            }, {
                "description": "Gibraltar Pound - GIP",
                "key": "GIP"
            }, {
                "description": "Guatemalan Quedzal - GTQ",
                "key": "GTQ"
            }, {
                "description": "Guinea Franc - GNF",
                "key": "GNF"
            }, {
                "description": "Guyanese Dollar - GYD",
                "key": "GYD"
            }, {
                "description": "Haitian Gourde - HTG",
                "key": "HTG"
            }, {
                "description": "Honduran Lempira - HNL",
                "key": "HNL"
            }, {
                "description": "Hong Kong Dollar - HKD",
                "key": "HKD"
            }, {
                "description": "Hungarian forint - HUF",
                "key": "HUF"
            }, {
                "description": "Iceland Krona - ISK",
                "key": "ISK"
            }, {
                "description": "Indian Rupee - INR",
                "key": "INR"
            }, {
                "description": "Indonesian Rupiah - IDR",
                "key": "IDR"
            }, {
                "description": "Iranian Rial - IRR",
                "key": "IRR"
            }, {
                "description": "Iraqui Dinar - IQD",
                "key": "IQD"
            }, {
                "description": "Jamaican Dollar - JMD",
                "key": "JMD"
            }, {
                "description": "Japanese Yen - JPY",
                "key": "JPY"
            }, {
                "description": "Jordanian Dinar - JOD",
                "key": "JOD"
            }, {
                "description": "Kazakhstani Tenge - KZT",
                "key": "KZT"
            }, {
                "description": "Kenyan Shilling - KES",
                "key": "KES"
            }, {
                "description": "Kirghizstan Som - KGS",
                "key": "KGS"
            }, {
                "description": "Kuwaiti Dinar - KWD",
                "key": "KWD"
            }, {
                "description": "Laotian Kip - LAK",
                "key": "LAK"
            }, {
                "description": "Lari - GEL",
                "key": "GEL"
            }, {
                "description": "Lebanese Pound - LBP",
                "key": "LBP"
            }, {
                "description": "Leone - SLL",
                "key": "SLL"
            }, {
                "description": "Lesotho Loti - LSL",
                "key": "LSL"
            }, {
                "description": "Liberian Dollar - LRD",
                "key": "LRD"
            }, {
                "description": "Libyan Dinar - LYD",
                "key": "LYD"
            }, {
                "description": "Macao Pataca - MOP",
                "key": "MOP"
            }, {
                "description": "Malagascy Ariary - MGA",
                "key": "MGA"
            }, {
                "description": "Malawi Kwacha - MWK",
                "key": "MWK"
            }, {
                "description": "Malaysian Ringgit - MYR",
                "key": "MYR"
            }, {
                "description": "Maldive Rufiyaa - MVR",
                "key": "MVR"
            }, {
                "description": "Mauritanian Ouguiya - MRU",
                "key": "MRU"
            }, {
                "description": "Mauritius Rupee - MUR",
                "key": "MUR"
            }, {
                "description": "Mexican Peso - MXN",
                "key": "MXN"
            }, {
                "description": "Moldavian Lei - MDL",
                "key": "MDL"
            }, {
                "description": "Mongolian Tugrik - MNT",
                "key": "MNT"
            }, {
                "description": "Moroccan Dirham - MAD",
                "key": "MAD"
            }, {
                "description": "Mozambique Metical - MZN",
                "key": "MZN"
            }, {
                "description": "Nepalese Rupee - NPR",
                "key": "NPR"
            }, {
                "description": "New Israeli Shekel - ILS",
                "key": "ILS"
            }, {
                "description": "New Taiwan Dollar - TWD",
                "key": "TWD"
            }, {
                "description": "New Zaire - ZRN",
                "key": "ZRN"
            }, {
                "description": "New Zealand Dollar - NZD",
                "key": "NZD"
            }, {
                "description": "Nicaraguan Cordoba - NIO",
                "key": "NIO"
            }, {
                "description": "Nigerian Naira - NGN",
                "key": "NGN"
            }, {
                "description": "North Korean Won - KPW",
                "key": "KPW"
            }, {
                "description": "Norwegian Krone - NOK",
                "key": "NOK"
            }, {
                "description": "Omani Rial - OMR",
                "key": "OMR"
            }, {
                "description": "Pakistan Rupee - PKR",
                "key": "PKR"
            }, {
                "description": "Panamanian Balboa - PAB",
                "key": "PAB"
            }, {
                "description": "Papua New Guinea Kina - PGK",
                "key": "PGK"
            }, {
                "description": "Paraguayan Guarani - PYG",
                "key": "PYG"
            }, {
                "description": "Peruvian Sol - PEN",
                "key": "PEN"
            }, {
                "description": "Philippino Peso - PHP",
                "key": "PHP"
            }, {
                "description": "Polish Zloty - PLN",
                "key": "PLN"
            }, {
                "description": "Qatar Riyal - QAR",
                "key": "QAR"
            }, {
                "description": "Romanian Leu - RON",
                "key": "RON"
            }, {
                "description": "Russian Rouble - RUB",
                "key": "RUB"
            }, {
                "description": "Rwanda Franc - RWF",
                "key": "RWF"
            }, {
                "description": "Samoan Tala - WST",
                "key": "WST"
            }, {
                "description": "Sao Tome and Principe Dobra - STN",
                "key": "STN"
            }, {
                "description": "Saudi Riyal - SAR",
                "key": "SAR"
            }, {
                "description": "Seychelles Rupee - SCR",
                "key": "SCR"
            }, {
                "description": "Singapore Dollar - SGD",
                "key": "SGD"
            }, {
                "description": "Solomon Islands Dollar - SBD",
                "key": "SBD"
            }, {
                "description": "Somalian Shilling - SOS",
                "key": "SOS"
            }, {
                "description": "South African Rand - ZAR",
                "key": "ZAR"
            }, {
                "description": "South Korean Won - KRW",
                "key": "KRW"
            }, {
                "description": "South Sudanese Pound - SSP",
                "key": "SSP"
            }, {
                "description": "Sri Lankan Rupee - LKR",
                "key": "LKR"
            }, {
                "description": "St.Helena Pound - SHP",
                "key": "SHP"
            }, {
                "description": "Sudanese Pound - SDG",
                "key": "SDG"
            }, {
                "description": "Surinam Dollar - SRD",
                "key": "SRD"
            }, {
                "description": "Swaziland Lilangeni - SZL",
                "key": "SZL"
            }, {
                "description": "Swedish Krona - SEK",
                "key": "SEK"
            }, {
                "description": "Swiss Franc - CHF",
                "key": "CHF"
            }, {
                "description": "Syrian Pound - SYP",
                "key": "SYP"
            }, {
                "description": "Tadzhikistani Somoni - TJS",
                "key": "TJS"
            }, {
                "description": "Tanzanian Shilling - TZS",
                "key": "TZS"
            }, {
                "description": "Thailand Baht - THB",
                "key": "THB"
            }, {
                "description": "Tongan Pa\\'anga - TOP",
                "key": "TOP"
            }, {
                "description": "Trinidad and Tobago Dollar - TTD",
                "key": "TTD"
            }, {
                "description": "Tunisian Dinar - TND",
                "key": "TND"
            }, {
                "description": "Turkish Lira - TRY",
                "key": "TRY"
            }, {
                "description": "Turkmenistani Manat - TMT",
                "key": "TMT"
            }, {
                "description": "Ugandan Shilling - UGX",
                "key": "UGX"
            }, {
                "description": "Ukrainian Hryvnia - UAH",
                "key": "UAH"
            }, {
                "description": "United Arab Emirates Dirham - AED",
                "key": "AED"
            }, {
                "description": "Uruguay - UYU",
                "key": "UYU"
            }, {
                "description": "Uruguay Peso en Unidades Indexadas (UI) - UYI",
                "key": "UYI"
            }, {
                "description": "Vanuatu Vatu - VUV",
                "key": "VUV"
            }, {
                "description": "Venezuelan Bolívar Soberano - VES",
                "key": "VES"
            }, {
                "description": "Vietnamese Dong - VND",
                "key": "VND"
            }, {
                "description": "West Indian Guilder - ANG",
                "key": "ANG"
            }, {
                "description": "Yemeni Ryal - YER",
                "key": "YER"
            }, {
                "description": "Zambian Kwacha - ZMW",
                "key": "ZMW"
            }, {
                "description": "Zimbabwean Dollar - ZWL",
                "key": "ZWL"
            }],
            "disabled": "false",
            "id": "EditProductStore_defaultCurrencyUomId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Which national currency will be used if none is specified. Use webtools to find codes for non-US locations.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "defaultCurrencyUomId",
            "style": "",
            "explicitDescription": "American Dollar - USD",
            "choices": "",
            "currentValue": "USD"
        }, {
            "": "",
            "fieldHelpText": "Which time zone will be used. If none is specified the machine time zone will be used.",
            "textSize": "40",
            "ajaxUrl": "",
            "maxlength": "60",
            "tabindex": "",
            "className": "",
            "title": "Default Time Zone",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "defaultTimeZoneString",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_defaultTimeZoneString",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Header Approved Status",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "ORDER_APPROVED",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Created [CREATED]",
                "key": "ORDER_CREATED"
            }, {
                "description": "Sent [SENT]",
                "key": "ORDER_SENT"
            }, {
                "description": "Processing [PROCESSING]",
                "key": "ORDER_PROCESSING"
            }, {
                "description": "Approved [APPROVED]",
                "key": "ORDER_APPROVED"
            }, {
                "description": "Held [HELD]",
                "key": "ORDER_HOLD"
            }, {
                "description": "Completed [COMPLETED]",
                "key": "ORDER_COMPLETED"
            }, {
                "description": "Rejected [REJECTED]",
                "key": "ORDER_REJECTED"
            }, {
                "description": "Cancelled [CANCELLED]",
                "key": "ORDER_CANCELLED"
            }],
            "disabled": "false",
            "id": "EditProductStore_headerApprovedStatus",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "This is the message you want your customers to see when their order is approved.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "headerApprovedStatus",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Item Approved Status",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "ITEM_APPROVED",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Created [CREATED]",
                "key": "ITEM_CREATED"
            }, {
                "description": "Approved [APPROVED]",
                "key": "ITEM_APPROVED"
            }, {
                "description": "Completed [COMPLETED]",
                "key": "ITEM_COMPLETED"
            }, {
                "description": "Rejected [REJECTED]",
                "key": "ITEM_REJECTED"
            }, {
                "description": "Cancelled [CANCELLED]",
                "key": "ITEM_CANCELLED"
            }],
            "disabled": "false",
            "id": "EditProductStore_itemApprovedStatus",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "What to set order items status to when orders are approved, declined, or canceled. Based on the standard defined status codes in Apache OFBiz.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "itemApprovedStatus",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Digital Item Approved Status",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "ITEM_APPROVED",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Created [CREATED]",
                "key": "ITEM_CREATED"
            }, {
                "description": "Approved [APPROVED]",
                "key": "ITEM_APPROVED"
            }, {
                "description": "Completed [COMPLETED]",
                "key": "ITEM_COMPLETED"
            }, {
                "description": "Rejected [REJECTED]",
                "key": "ITEM_REJECTED"
            }, {
                "description": "Cancelled [CANCELLED]",
                "key": "ITEM_CANCELLED"
            }],
            "disabled": "false",
            "id": "EditProductStore_digitalItemApprovedStatus",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "What to set order items status to when Digital Item orders are approved, declined, or canceled. Based on the standard defined status codes in Apache OFBiz.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "digitalItemApprovedStatus",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Header Declined Status",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "ORDER_REJECTED",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Created [CREATED]",
                "key": "ORDER_CREATED"
            }, {
                "description": "Sent [SENT]",
                "key": "ORDER_SENT"
            }, {
                "description": "Processing [PROCESSING]",
                "key": "ORDER_PROCESSING"
            }, {
                "description": "Approved [APPROVED]",
                "key": "ORDER_APPROVED"
            }, {
                "description": "Held [HELD]",
                "key": "ORDER_HOLD"
            }, {
                "description": "Completed [COMPLETED]",
                "key": "ORDER_COMPLETED"
            }, {
                "description": "Rejected [REJECTED]",
                "key": "ORDER_REJECTED"
            }, {
                "description": "Cancelled [CANCELLED]",
                "key": "ORDER_CANCELLED"
            }],
            "disabled": "false",
            "id": "EditProductStore_headerDeclinedStatus",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "This is the message you want your customers to see when their order is declined. Based on the standard defined status codes in Apache OFBiz.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "headerDeclinedStatus",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Item Declined Status",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "ITEM_REJECTED",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Created [CREATED]",
                "key": "ITEM_CREATED"
            }, {
                "description": "Approved [APPROVED]",
                "key": "ITEM_APPROVED"
            }, {
                "description": "Completed [COMPLETED]",
                "key": "ITEM_COMPLETED"
            }, {
                "description": "Rejected [REJECTED]",
                "key": "ITEM_REJECTED"
            }, {
                "description": "Cancelled [CANCELLED]",
                "key": "ITEM_CANCELLED"
            }],
            "disabled": "false",
            "id": "EditProductStore_itemDeclinedStatus",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "This is the message you want the customer to see when one of their items is declined for some reason.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "itemDeclinedStatus",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Header Cancel Status",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "ORDER_CANCELLED",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Created [CREATED]",
                "key": "ORDER_CREATED"
            }, {
                "description": "Sent [SENT]",
                "key": "ORDER_SENT"
            }, {
                "description": "Processing [PROCESSING]",
                "key": "ORDER_PROCESSING"
            }, {
                "description": "Approved [APPROVED]",
                "key": "ORDER_APPROVED"
            }, {
                "description": "Held [HELD]",
                "key": "ORDER_HOLD"
            }, {
                "description": "Completed [COMPLETED]",
                "key": "ORDER_COMPLETED"
            }, {
                "description": "Rejected [REJECTED]",
                "key": "ORDER_REJECTED"
            }, {
                "description": "Cancelled [CANCELLED]",
                "key": "ORDER_CANCELLED"
            }],
            "disabled": "false",
            "id": "EditProductStore_headerCancelStatus",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "This is the message that you want the client to see when their order is cancelled.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "headerCancelStatus",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Item Cancel Status",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "ITEM_CANCELLED",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Created [CREATED]",
                "key": "ITEM_CREATED"
            }, {
                "description": "Approved [APPROVED]",
                "key": "ITEM_APPROVED"
            }, {
                "description": "Completed [COMPLETED]",
                "key": "ITEM_COMPLETED"
            }, {
                "description": "Rejected [REJECTED]",
                "key": "ITEM_REJECTED"
            }, {
                "description": "Cancelled [CANCELLED]",
                "key": "ITEM_CANCELLED"
            }],
            "disabled": "false",
            "id": "EditProductStore_itemCancelStatus",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "The message shown when an item they ordered is cancelled.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "itemCancelStatus",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "Message shown when payment authorization is declined.",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Auth Declined Message",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "authDeclinedMessage",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_authDeclinedMessage",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "Message sent when fraud is suspected.",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Auth Fraud Message",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "authFraudMessage",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_authFraudMessage",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "Message sent when a processing error is encountered.",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Auth Error Message",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "authErrorMessage",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_authErrorMessage",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Prorate Taxes",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_prorateTaxes",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Prorate Taxes",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "prorateTaxes",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Show prices with VAT tax included",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_showPricesWithVatTax",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Should the displayed prices include (Y) or not include (N) the VAT Tax amount?",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "showPricesWithVatTax",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Show Tax Is Exempt",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_showTaxIsExempt",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Will it be appropriate to indicate when an item is exempt from tax?",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "showTaxIsExempt",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldHelpText": "What is the Geographical ID for the VAT taxing authority?",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStore",
                "id": "EditProductStore_vatTaxAuthGeoId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupGeo",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "vatTaxAuthGeoId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "vatTaxAuthGeoId",
            "style": "",
            "id": "EditProductStore_vatTaxAuthGeoId",
            "title": "Vat Tax Auth Geo ID",
            "type": "LOOKUP"
        }, {
            "fieldHelpText": "What is the Party ID of the Vat Taxing Authority?",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStore",
                "id": "EditProductStore_vatTaxAuthPartyId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupPartyName",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "vatTaxAuthPartyId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "vatTaxAuthPartyId",
            "style": "",
            "id": "EditProductStore_vatTaxAuthPartyId",
            "title": "Vat Tax Auth Party ID",
            "type": "LOOKUP"
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Auto Approve Reviews",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_autoApproveReviews",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If the site allows users to enter product reviews, this controls whether the reviews must be approved, or whether they are automatically shown on the site.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "autoApproveReviews",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Allow Password",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_allowPassword",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If No, when a customer creates an account they will not be asked for a password and they have to wait for their account to be enabled and a password to be sent to them.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "allowPassword",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "If you allow others access with a password, what is the default password that anyone could use if they knew it?",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Default Password",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "defaultPassword",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStore_defaultPassword",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Use Primary Email Username",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_usePrimaryEmailUsername",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If set to Y then in the create customer form no entry box will be presented for a username - the primary email address will be used for username.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "usePrimaryEmailUsername",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Require Customer Role",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_requireCustomerRole",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "If set to Y then the customer must be associated with the store in the Customer role in order to be able to login (e.g. B2B)",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "requireCustomerRole",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Enable Auto Suggestion List",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_enableAutoSuggestionList",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "The auto-suggestion list is a special ShoppingList that the addSuggestionsToShoppingList service will maintain for cross-sells of ordered items.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "enableAutoSuggestionList",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Enable Digital Product Upload",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_enableDigProdUpload",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "Unless this is set to Yes, the sale of Digital Products from your Store will not be permitted.",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "enableDigProdUpload",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldHelpText": "Which Category of Digital Products may be uploaded?",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStore",
                "id": "EditProductStore_digProdUploadCategoryId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupProductCategory",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "digProdUploadCategoryId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "digProdUploadCategoryId",
            "style": "",
            "id": "EditProductStore_digProdUploadCategoryId",
            "title": "Dig Prod Upload Category ID",
            "type": "LOOKUP"
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Allow Comment",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_allowComment",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "first-in-list",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "allowComment",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Allocate Inventory",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStore",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStore_allocateInventory",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "first-in-list",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "allocateInventory",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "EditProductStore",
            "tabindex": "",
            "name": "submitButton",
            "className": "",
            "id": "EditProductStore_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Update",
            "event": "",
            "imgSrc": ""
        }],
        "target": "updateProductStore"
    },
    {
        "fieldSets": [{
            "fieldSetName": "Store",
            "fields": ["primaryStoreGroupId", "storeName", "title", "subtitle", "companyName", "isDemoStore", "inventoryFacilityId"]
        }, {
            "fieldSetName": "Inventory",
            "fields": ["oneInventoryFacility", "isImmediatelyFulfilled", "checkInventory", "requireInventory", "requirementMethodEnumId", "reserveInventory", "reserveOrderEnumId", "balanceResOnOrderCreation", "showOutOfStockProducts", "managedByLot", "viewCartOnAdd"]
        }, {
            "fieldSetName": "ShoppingCart",
            "fields": ["autoSaveCart", "addToCartReplaceUpsell", "addToCartRemoveIncompat", "showCheckoutGiftOptions", "prodSearchExcludeVariants", "orderDecimalQuantity", "prorateShipping"]
        }, {
            "fieldSetName": "Shipping",
            "fields": ["reqShipAddrForDigItems", "selectPaymentTypePerItem", "shipIfCaptureFails", "splitPayPrefPerShpGrp", "payToPartyId"]
        }, {
            "fieldSetName": "Payments",
            "fields": ["storeCreditAccountEnumId", "manualAuthIsCapture", "retryFailedAuths", "daysToCancelNonPay", "autoOrderCcTryExp", "autoOrderCcTryOtherCards", "autoOrderCcTryLaterNsf", "autoOrderCcTryLaterMax", "storeCreditValidDays", "setOwnerUponIssuance", "orderNumberPrefix"]
        }, {
            "fieldSetName": "Orders",
            "fields": ["defaultSalesChannelEnumId", "explodeOrderItems", "checkGcBalance", "autoInvoiceDigitalItems", "autoApproveInvoice", "autoApproveOrder", "reqReturnInventoryReceive", "defaultLocaleString"]
        }, {
            "fieldSetName": "Localization",
            "fields": ["defaultCurrencyUomId", "defaultTimeZoneString", "headerApprovedStatus"]
        }, {
            "fieldSetName": "Orders Status",
            "fields": ["itemApprovedStatus", "digitalItemApprovedStatus", "headerDeclinedStatus", "itemDeclinedStatus", "headerCancelStatus", "itemCancelStatus", "authDeclinedMessage"]
        }, {
            "fieldSetName": "Messages",
            "fields": ["authFraudMessage", "authErrorMessage", "prorateTaxes"]
        }, {
            "fieldSetName": "Tax",
            "fields": ["showPricesWithVatTax", "showTaxIsExempt", "vatTaxAuthGeoId", "vatTaxAuthPartyId", "autoApproveReviews"]
        }, {
            "fieldSetName": "Visitors",
            "fields": ["allowPassword", "defaultPassword", "usePrimaryEmailUsername", "requireCustomerRole", "enableAutoSuggestionList", "enableDigProdUpload"]
        }, {
            "fieldSetName": "Upload",
            "fields": ["digProdUploadCategoryId", "visualThemeId", "allowComment", "allocateInventory"]
        }],
        "formName": "ProductStore",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "ProductStore_productStoreId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "primaryStoreGroupId",
            "action": "",
            "id": "ProductStore_primaryStoreGroupId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "storeName",
            "action": "",
            "id": "ProductStore_storeName",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "title",
            "action": "",
            "id": "ProductStore_title",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "subtitle",
            "action": "",
            "id": "ProductStore_subtitle",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "companyName",
            "action": "",
            "id": "ProductStore_companyName",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "isDemoStore",
            "action": "",
            "id": "ProductStore_isDemoStore",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "inventoryFacilityId",
            "action": "",
            "id": "ProductStore_inventoryFacilityId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "oneInventoryFacility",
            "action": "",
            "id": "ProductStore_oneInventoryFacility",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "isImmediatelyFulfilled",
            "action": "",
            "id": "ProductStore_isImmediatelyFulfilled",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "checkInventory",
            "action": "",
            "id": "ProductStore_checkInventory",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "requireInventory",
            "action": "",
            "id": "ProductStore_requireInventory",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "requirementMethodEnumId",
            "action": "",
            "id": "ProductStore_requirementMethodEnumId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "reserveInventory",
            "action": "",
            "id": "ProductStore_reserveInventory",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "reserveOrderEnumId",
            "action": "",
            "id": "ProductStore_reserveOrderEnumId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "balanceResOnOrderCreation",
            "action": "",
            "id": "ProductStore_balanceResOnOrderCreation",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "showOutOfStockProducts",
            "action": "",
            "id": "ProductStore_showOutOfStockProducts",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "managedByLot",
            "action": "",
            "id": "ProductStore_managedByLot",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "viewCartOnAdd",
            "action": "",
            "id": "ProductStore_viewCartOnAdd",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "autoSaveCart",
            "action": "",
            "id": "ProductStore_autoSaveCart",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "addToCartReplaceUpsell",
            "action": "",
            "id": "ProductStore_addToCartReplaceUpsell",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "addToCartRemoveIncompat",
            "action": "",
            "id": "ProductStore_addToCartRemoveIncompat",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "showCheckoutGiftOptions",
            "action": "",
            "id": "ProductStore_showCheckoutGiftOptions",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "prodSearchExcludeVariants",
            "action": "",
            "id": "ProductStore_prodSearchExcludeVariants",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "orderDecimalQuantity",
            "action": "",
            "id": "ProductStore_orderDecimalQuantity",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "prorateShipping",
            "action": "",
            "id": "ProductStore_prorateShipping",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "reqShipAddrForDigItems",
            "action": "",
            "id": "ProductStore_reqShipAddrForDigItems",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "selectPaymentTypePerItem",
            "action": "",
            "id": "ProductStore_selectPaymentTypePerItem",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "shipIfCaptureFails",
            "action": "",
            "id": "ProductStore_shipIfCaptureFails",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "splitPayPrefPerShpGrp",
            "action": "",
            "id": "ProductStore_splitPayPrefPerShpGrp",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "payToPartyId",
            "action": "",
            "id": "ProductStore_payToPartyId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "storeCreditAccountEnumId",
            "action": "",
            "id": "ProductStore_storeCreditAccountEnumId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "manualAuthIsCapture",
            "action": "",
            "id": "ProductStore_manualAuthIsCapture",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "retryFailedAuths",
            "action": "",
            "id": "ProductStore_retryFailedAuths",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "daysToCancelNonPay",
            "action": "",
            "id": "ProductStore_daysToCancelNonPay",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "autoOrderCcTryExp",
            "action": "",
            "id": "ProductStore_autoOrderCcTryExp",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "autoOrderCcTryOtherCards",
            "action": "",
            "id": "ProductStore_autoOrderCcTryOtherCards",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "autoOrderCcTryLaterNsf",
            "action": "",
            "id": "ProductStore_autoOrderCcTryLaterNsf",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "autoOrderCcTryLaterMax",
            "action": "",
            "id": "ProductStore_autoOrderCcTryLaterMax",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "storeCreditValidDays",
            "action": "",
            "id": "ProductStore_storeCreditValidDays",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "setOwnerUponIssuance",
            "action": "",
            "id": "ProductStore_setOwnerUponIssuance",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "orderNumberPrefix",
            "action": "",
            "id": "ProductStore_orderNumberPrefix",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "defaultSalesChannelEnumId",
            "action": "",
            "id": "ProductStore_defaultSalesChannelEnumId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "explodeOrderItems",
            "action": "",
            "id": "ProductStore_explodeOrderItems",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "checkGcBalance",
            "action": "",
            "id": "ProductStore_checkGcBalance",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "autoInvoiceDigitalItems",
            "action": "",
            "id": "ProductStore_autoInvoiceDigitalItems",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "autoApproveInvoice",
            "action": "",
            "id": "ProductStore_autoApproveInvoice",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "autoApproveOrder",
            "action": "",
            "id": "ProductStore_autoApproveOrder",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "reqReturnInventoryReceive",
            "action": "",
            "id": "ProductStore_reqReturnInventoryReceive",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "defaultLocaleString",
            "action": "",
            "id": "ProductStore_defaultLocaleString",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "defaultCurrencyUomId",
            "action": "",
            "id": "ProductStore_defaultCurrencyUomId",
            "type": "DISPLAY",
            "event": "",
            "value": "USD"
        }, {
            "conditionGroup": "",
            "name": "defaultTimeZoneString",
            "action": "",
            "id": "ProductStore_defaultTimeZoneString",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "headerApprovedStatus",
            "action": "",
            "id": "ProductStore_headerApprovedStatus",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "itemApprovedStatus",
            "action": "",
            "id": "ProductStore_itemApprovedStatus",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "digitalItemApprovedStatus",
            "action": "",
            "id": "ProductStore_digitalItemApprovedStatus",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "headerDeclinedStatus",
            "action": "",
            "id": "ProductStore_headerDeclinedStatus",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "itemDeclinedStatus",
            "action": "",
            "id": "ProductStore_itemDeclinedStatus",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "headerCancelStatus",
            "action": "",
            "id": "ProductStore_headerCancelStatus",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "itemCancelStatus",
            "action": "",
            "id": "ProductStore_itemCancelStatus",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "authDeclinedMessage",
            "action": "",
            "id": "ProductStore_authDeclinedMessage",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "authFraudMessage",
            "action": "",
            "id": "ProductStore_authFraudMessage",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "authErrorMessage",
            "action": "",
            "id": "ProductStore_authErrorMessage",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "prorateTaxes",
            "action": "",
            "id": "ProductStore_prorateTaxes",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "showPricesWithVatTax",
            "action": "",
            "id": "ProductStore_showPricesWithVatTax",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "showTaxIsExempt",
            "action": "",
            "id": "ProductStore_showTaxIsExempt",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "vatTaxAuthGeoId",
            "action": "",
            "id": "ProductStore_vatTaxAuthGeoId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "vatTaxAuthPartyId",
            "action": "",
            "id": "ProductStore_vatTaxAuthPartyId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "autoApproveReviews",
            "action": "",
            "id": "ProductStore_autoApproveReviews",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "allowPassword",
            "action": "",
            "id": "ProductStore_allowPassword",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "defaultPassword",
            "action": "",
            "id": "ProductStore_defaultPassword",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "usePrimaryEmailUsername",
            "action": "",
            "id": "ProductStore_usePrimaryEmailUsername",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "requireCustomerRole",
            "action": "",
            "id": "ProductStore_requireCustomerRole",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "enableAutoSuggestionList",
            "action": "",
            "id": "ProductStore_enableAutoSuggestionList",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "enableDigProdUpload",
            "action": "",
            "id": "ProductStore_enableDigProdUpload",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "digProdUploadCategoryId",
            "action": "",
            "id": "ProductStore_digProdUploadCategoryId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "visualThemeId",
            "action": "",
            "id": "ProductStore_visualThemeId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "allowComment",
            "action": "",
            "id": "ProductStore_allowComment",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "allocateInventory",
            "action": "",
            "id": "ProductStore_allocateInventory",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "fieldHelpText": "The id for the product store.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "productStoreId",
            "description": "",
            "style": "",
            "id": "ProductStore_productStoreId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "What group this store belongs to. Stores can be grouped together with a price for each store group. It can be left blank if there are no store groups set up.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "primaryStoreGroupId",
            "description": "",
            "style": "",
            "id": "ProductStore_primaryStoreGroupId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This is the name of the store that this catalog represents.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "storeName",
            "description": "",
            "style": "",
            "id": "ProductStore_storeName",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This value gets displayed in the header section of the ecommerce store.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "title",
            "description": "",
            "style": "",
            "id": "ProductStore_title",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This value gets displayed in the header section of the ecommerce store.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "subtitle",
            "description": "",
            "style": "",
            "id": "ProductStore_subtitle",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This is the name of the company that this catalog represents.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "companyName",
            "description": "",
            "style": "",
            "id": "ProductStore_companyName",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If Yes, any orders created will not be sent, credit card charges will not be made, etc.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "isDemoStore",
            "description": "",
            "style": "",
            "id": "ProductStore_isDemoStore",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This is where the stock levels are drawn from.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "inventoryFacilityId",
            "description": "",
            "style": "",
            "id": "ProductStore_inventoryFacilityId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If this is a 'Single Inventory' facility. With newer or less complex businesses, you will find the Single Inventory concept much easier to work with.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "oneInventoryFacility",
            "description": "",
            "style": "",
            "id": "ProductStore_oneInventoryFacility",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If Yes, the order will be immediately fulfilled through system-generated processes in ofbiz.  If no, it will be held for manual review.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "isImmediatelyFulfilled",
            "description": "",
            "style": "",
            "id": "ProductStore_isImmediatelyFulfilled",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This determines whether the system checks inventory levels when processing an order.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "checkInventory",
            "description": "",
            "style": "",
            "id": "ProductStore_checkInventory",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If sufficient inventory not on hand, order will not be processed when this flag is set to Yes.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "requireInventory",
            "description": "",
            "style": "",
            "id": "ProductStore_requireInventory",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Refers to warehouse stocking level triggers.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "requirementMethodEnumId",
            "description": "",
            "style": "",
            "id": "ProductStore_requirementMethodEnumId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Causes inventory to be reserved for items ordered in the store. The inventory may still be on hand but will no longer be available for other orders.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "reserveInventory",
            "description": "",
            "style": "",
            "id": "ProductStore_reserveInventory",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Choose how inventory should be reserved.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "reserveOrderEnumId",
            "description": "",
            "style": "",
            "id": "ProductStore_reserveOrderEnumId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If set to Y, when a new sales order is created with backordered items, then reservations on the facility/product are reassigned according to the priority given by the shipBeforeDate field.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "balanceResOnOrderCreation",
            "description": "",
            "style": "",
            "id": "ProductStore_balanceResOnOrderCreation",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If N then out of stock products will not be displayed on site",
            "ajaxEnabled": false,
            "size": 0,
            "name": "showOutOfStockProducts",
            "description": "",
            "style": "",
            "id": "ProductStore_showOutOfStockProducts",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "managedByLot",
            "description": "",
            "style": "",
            "id": "ProductStore_managedByLot",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Controls whether the user is taken to the shopping cart immediately after adding a product to his cart.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "viewCartOnAdd",
            "description": "",
            "style": "",
            "id": "ProductStore_viewCartOnAdd",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Drop-down Y/N box on the question of automatically saving the contents of the shopping cart.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "autoSaveCart",
            "description": "",
            "style": "",
            "id": "ProductStore_autoSaveCart",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If Y then on add to cart remove all products in cart with a ProductAssoc record related from the product and with the PRODUCT_UPGRADE type.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "addToCartReplaceUpsell",
            "description": "",
            "style": "",
            "id": "ProductStore_addToCartReplaceUpsell",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If Y then on add to cart remove all products in cart with a ProductAssoc record related to or from the product and with the PRODUCT_INCOMPATABLE type.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "addToCartRemoveIncompat",
            "description": "",
            "style": "",
            "id": "ProductStore_addToCartRemoveIncompat",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If set to N the options related to gifts (the 'is gift' and 'gift message' options) will not be shown during checkout.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "showCheckoutGiftOptions",
            "description": "",
            "style": "",
            "id": "ProductStore_showCheckoutGiftOptions",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If set to Y an additional constraint will of isVariant!=Y will be added to all product searches for the store.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "prodSearchExcludeVariants",
            "description": "",
            "style": "",
            "id": "ProductStore_prodSearchExcludeVariants",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "orderDecimalQuantity",
            "description": "",
            "style": "",
            "id": "ProductStore_orderDecimalQuantity",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "When some share of the cost of shipping is covered under an account other than the bill-to.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "prorateShipping",
            "description": "",
            "style": "",
            "id": "ProductStore_prorateShipping",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Require Shipping Address for Digital Items? Note this only has an effect if there are ONLY digital goods in the cart.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "reqShipAddrForDigItems",
            "description": "",
            "style": "",
            "id": "ProductStore_reqShipAddrForDigItems",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If Yes, allows customer to pay for some order items with one payment type, others with another type.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "selectPaymentTypePerItem",
            "description": "",
            "style": "",
            "id": "ProductStore_selectPaymentTypePerItem",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If N, the captureOrderPayments will cause a service error if credit card capture fails.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "shipIfCaptureFails",
            "description": "",
            "style": "",
            "id": "ProductStore_shipIfCaptureFails",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If Y then before the order is stored the OrderPaymentPreference record will be split, one for each OrderItemShipGroup.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "splitPayPrefPerShpGrp",
            "description": "",
            "style": "",
            "id": "ProductStore_splitPayPrefPerShpGrp",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Note that this corresponds with the organizationPartyId that GL transactions will be posted to.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "payToPartyId",
            "description": "",
            "style": "",
            "id": "ProductStore_payToPartyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Specify the type (Billing Account or Financial Account) of Store Credit Account used for refund return.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "storeCreditAccountEnumId",
            "description": "",
            "style": "",
            "id": "ProductStore_storeCreditAccountEnumId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Drop-down Y/N box on the question of whether a Manual Authorization is captured.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "manualAuthIsCapture",
            "description": "",
            "style": "",
            "id": "ProductStore_manualAuthIsCapture",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "How many times can an unsuccessful attempt to authorize an order be allowed?",
            "ajaxEnabled": false,
            "size": 0,
            "name": "retryFailedAuths",
            "description": "",
            "style": "",
            "id": "ProductStore_retryFailedAuths",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Triggers cancellation of orders for non-payment after the number of days entered here.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "daysToCancelNonPay",
            "description": "",
            "style": "",
            "id": "ProductStore_daysToCancelNonPay",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "For auto-orders try other Credit Card expiration dates (if date is wrong or general failure where type not known).",
            "ajaxEnabled": false,
            "size": 0,
            "name": "autoOrderCcTryExp",
            "description": "",
            "style": "",
            "id": "ProductStore_autoOrderCcTryExp",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "For auto-orders try other Credit Cards for the customer.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "autoOrderCcTryOtherCards",
            "description": "",
            "style": "",
            "id": "ProductStore_autoOrderCcTryOtherCards",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "For auto-orders if Credit Cards fails for NSF (Not Sufficient Funds) try again later.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "autoOrderCcTryLaterNsf",
            "description": "",
            "style": "",
            "id": "ProductStore_autoOrderCcTryLaterNsf",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "For auto-orders if Credit Cards fails for NSF try again how many times.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "autoOrderCcTryLaterMax",
            "description": "",
            "style": "",
            "id": "ProductStore_autoOrderCcTryLaterMax",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "How many days that store credit is valid for. Null value implies no expiration.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "storeCreditValidDays",
            "description": "",
            "style": "",
            "id": "ProductStore_storeCreditValidDays",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If Y or empty, set the inventory item owner upon issuance.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "setOwnerUponIssuance",
            "description": "",
            "style": "",
            "id": "ProductStore_setOwnerUponIssuance",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "All orders will be prefixed by this. For example, if you wished accounting to be able to quickly differentiate orders between stores.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "orderNumberPrefix",
            "description": "",
            "style": "",
            "id": "ProductStore_orderNumberPrefix",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Unless the sales channel has been specified in the transaction, it will be assumed that the sale came in through the selected path.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "defaultSalesChannelEnumId",
            "description": "",
            "style": "",
            "id": "ProductStore_defaultSalesChannelEnumId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If set to Y then any shopping cart item with a quantity greater than one will be split into separate order items with a quantity of 1 each.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "explodeOrderItems",
            "description": "",
            "style": "",
            "id": "ProductStore_explodeOrderItems",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Check Gc Balance",
            "ajaxEnabled": false,
            "size": 0,
            "name": "checkGcBalance",
            "description": "",
            "style": "",
            "id": "ProductStore_checkGcBalance",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If Y, digital items will be immediately invoiced when the order is placed.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "autoInvoiceDigitalItems",
            "description": "",
            "style": "",
            "id": "ProductStore_autoInvoiceDigitalItems",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If Y or empty, sales invoices created from orders will be marked ready.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "autoApproveInvoice",
            "description": "",
            "style": "",
            "id": "ProductStore_autoApproveInvoice",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If N, orders will not be automatically approved when payment is authorized.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "autoApproveOrder",
            "description": "",
            "style": "",
            "id": "ProductStore_autoApproveOrder",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If set to Y return will automatically go to the Received status when Accepted instead of waiting for actual receipt of the return.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "reqReturnInventoryReceive",
            "description": "",
            "style": "",
            "id": "ProductStore_reqReturnInventoryReceive",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Default locale, for language, number, and currency formats.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "defaultLocaleString",
            "description": "",
            "style": "",
            "id": "ProductStore_defaultLocaleString",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Which national currency will be used if none is specified. Use webtools to find codes for non-US locations.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "defaultCurrencyUomId",
            "description": "USD",
            "style": "",
            "id": "ProductStore_defaultCurrencyUomId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Which time zone will be used. If none is specified the machine time zone will be used.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "defaultTimeZoneString",
            "description": "",
            "style": "",
            "id": "ProductStore_defaultTimeZoneString",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This is the message you want your customers to see when their order is approved.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "headerApprovedStatus",
            "description": "",
            "style": "",
            "id": "ProductStore_headerApprovedStatus",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "What to set order items status to when orders are approved, declined, or canceled. Based on the standard defined status codes in Apache OFBiz.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "itemApprovedStatus",
            "description": "",
            "style": "",
            "id": "ProductStore_itemApprovedStatus",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "What to set order items status to when Digital Item orders are approved, declined, or canceled. Based on the standard defined status codes in Apache OFBiz.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "digitalItemApprovedStatus",
            "description": "",
            "style": "",
            "id": "ProductStore_digitalItemApprovedStatus",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This is the message you want your customers to see when their order is declined. Based on the standard defined status codes in Apache OFBiz.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "headerDeclinedStatus",
            "description": "",
            "style": "",
            "id": "ProductStore_headerDeclinedStatus",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This is the message you want the customer to see when one of their items is declined for some reason.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "itemDeclinedStatus",
            "description": "",
            "style": "",
            "id": "ProductStore_itemDeclinedStatus",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "This is the message that you want the client to see when their order is cancelled.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "headerCancelStatus",
            "description": "",
            "style": "",
            "id": "ProductStore_headerCancelStatus",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "The message shown when an item they ordered is cancelled.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "itemCancelStatus",
            "description": "",
            "style": "",
            "id": "ProductStore_itemCancelStatus",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Message shown when payment authorization is declined.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "authDeclinedMessage",
            "description": "",
            "style": "",
            "id": "ProductStore_authDeclinedMessage",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Message sent when fraud is suspected.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "authFraudMessage",
            "description": "",
            "style": "",
            "id": "ProductStore_authFraudMessage",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Message sent when a processing error is encountered.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "authErrorMessage",
            "description": "",
            "style": "",
            "id": "ProductStore_authErrorMessage",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Prorate Taxes",
            "ajaxEnabled": false,
            "size": 0,
            "name": "prorateTaxes",
            "description": "",
            "style": "",
            "id": "ProductStore_prorateTaxes",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Should the displayed prices include (Y) or not include (N) the VAT Tax amount?",
            "ajaxEnabled": false,
            "size": 0,
            "name": "showPricesWithVatTax",
            "description": "",
            "style": "",
            "id": "ProductStore_showPricesWithVatTax",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Will it be appropriate to indicate when an item is exempt from tax?",
            "ajaxEnabled": false,
            "size": 0,
            "name": "showTaxIsExempt",
            "description": "",
            "style": "",
            "id": "ProductStore_showTaxIsExempt",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "What is the Geographical ID for the VAT taxing authority?",
            "ajaxEnabled": false,
            "size": 0,
            "name": "vatTaxAuthGeoId",
            "description": "",
            "style": "",
            "id": "ProductStore_vatTaxAuthGeoId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "What is the Party ID of the Vat Taxing Authority?",
            "ajaxEnabled": false,
            "size": 0,
            "name": "vatTaxAuthPartyId",
            "description": "",
            "style": "",
            "id": "ProductStore_vatTaxAuthPartyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If the site allows users to enter product reviews, this controls whether the reviews must be approved, or whether they are automatically shown on the site.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "autoApproveReviews",
            "description": "",
            "style": "",
            "id": "ProductStore_autoApproveReviews",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If No, when a customer creates an account they will not be asked for a password and they have to wait for their account to be enabled and a password to be sent to them.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "allowPassword",
            "description": "",
            "style": "",
            "id": "ProductStore_allowPassword",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If you allow others access with a password, what is the default password that anyone could use if they knew it?",
            "ajaxEnabled": false,
            "size": 0,
            "name": "defaultPassword",
            "description": "",
            "style": "",
            "id": "ProductStore_defaultPassword",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If set to Y then in the create customer form no entry box will be presented for a username - the primary email address will be used for username.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "usePrimaryEmailUsername",
            "description": "",
            "style": "",
            "id": "ProductStore_usePrimaryEmailUsername",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "If set to Y then the customer must be associated with the store in the Customer role in order to be able to login (e.g. B2B)",
            "ajaxEnabled": false,
            "size": 0,
            "name": "requireCustomerRole",
            "description": "",
            "style": "",
            "id": "ProductStore_requireCustomerRole",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "The auto-suggestion list is a special ShoppingList that the addSuggestionsToShoppingList service will maintain for cross-sells of ordered items.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "enableAutoSuggestionList",
            "description": "",
            "style": "",
            "id": "ProductStore_enableAutoSuggestionList",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Unless this is set to Yes, the sale of Digital Products from your Store will not be permitted.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "enableDigProdUpload",
            "description": "",
            "style": "",
            "id": "ProductStore_enableDigProdUpload",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "Which Category of Digital Products may be uploaded?",
            "ajaxEnabled": false,
            "size": 0,
            "name": "digProdUploadCategoryId",
            "description": "",
            "style": "",
            "id": "ProductStore_digProdUploadCategoryId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "For controlling the look and feel of the web-based store.",
            "ajaxEnabled": false,
            "size": 0,
            "name": "visualThemeId",
            "description": "",
            "style": "",
            "id": "ProductStore_visualThemeId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "allowComment",
            "description": "",
            "style": "",
            "id": "ProductStore_allowComment",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "allocateInventory",
            "description": "",
            "style": "",
            "id": "ProductStore_allocateInventory",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }],
        "target": ""
    },
    {
        "columns": [{
            "name": "partyId",
            "title": "Party ID"
        }, {
            "name": "roleTypeId",
            "title": "RoleType ID"
        }, {
            "name": "fromDate",
            "title": "From Date"
        }, {
            "name": "thruDate",
            "title": "Through Date"
        }, {
            "name": "sequenceNum",
            "title": "Sequence Num"
        }, {
            "name": "editLink",
            "title": "Edit"
        }, {
            "name": "deleteLink",
            "title": "Delete"
        }],
        "formName": "ListProductStoreRole",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "hyperlink": {
                "linkStyle": "",
                "description": "[]",
                "targetType": "inter-app",
                "confirmation": "",
                "parameterMap": {
                    "VIEW_SIZE_0": "20",
                    "VIEW_INDEX_0": "0"
                },
                "uniqueItemName": "Modal_51b96cd5_8b01_4448_abf5_03865a05f0ec",
                "target": "/partymgr/control/viewprofile",
                "targetWindow": "",
                "remoteFormData": {
                    "formData": {
                        "formName": "ViewProfile",
                        "formLocation": "component://kwikstore/widget/StoreForms.xml"
                    }
                }

            },
            "event": "view",
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "partyId",
            "description": "",
            "style": "",
            "id": "ListProductStoreRole_partyId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "roleTypeId",
            "description": "",
            "style": "",
            "id": "ListProductStoreRole_roleTypeId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "fromDate",
            "description": "",
            "style": "",
            "id": "ListProductStoreRole_fromDate",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "thruDate",
            "description": "",
            "style": "",
            "id": "ListProductStoreRole_thruDate",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "sequenceNum",
            "description": "",
            "style": "",
            "id": "ListProductStoreRole_sequenceNum",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "image": "",
            "fieldHelpText": "",
            "alternate": "",
            "description": "Edit",
            "title": "Edit",
            "type": "HYPERLINK",
            "target": "FindProductStoreRoles",
            "name": "editLink",
            "width": "",
            "parameterList": [{
                "name": "partyId"
            }, {
                "name": "productStoreId"
            }, {
                "name": "roleTypeId"
            }, {
                "name": "fromDate"
            }],
            "style": "",
            "id": "ListProductStoreRole_editLink",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "formData": {
                "formName": "FindProductStoreRoles",
                "formLocation": "component://kwikstore/widget/StoreForms.xml"
            },
            "event": "edit",
        }, {
            "image": "",
            "fieldHelpText": "",
            "alternate": "",
            "description": "Delete",
            "title": "Delete",
            "type": "HYPERLINK",
            "target": "storeRemoveRole",
            "name": "deleteLink",
            "width": "",
            "parameterList": [{
                "name": "partyId"
            }, {
                "name": "productStoreId"
            }, {
                "name": "roleTypeId"
            }, {
                "name": "fromDate"
            }],
            "style": "",
            "id": "ListProductStoreRole_deleteLink",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "formData": {
                "formName": "FindProductStoreRoles",
                "formLocation": "component://kwikstore/widget/StoreForms.xml"
            },
            "event": "delete",
        }],
        "target": ""
    },
    {
        "formName": "EditProductStoreRole",
        "altTarget": [{
            "useWhen": "productStoreRole==null",
            "targetExdr": {
                "chars": "storeCreateRole",
                "hint": 20,
                "empty": false,
                "original": "storeCreateRole"
            }
        }],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "EditProductStoreRole_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "required",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStoreRole",
                "id": "EditProductStoreRole_partyId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupPartyName",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "partyId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "partyId",
            "style": "",
            "id": "EditProductStoreRole_partyId",
            "title": "Party ID",
            "type": "LOOKUP"
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "required",
            "title": "RoleType ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreRole",
            "options": [{
                "description": "Main Role",
                "key": "MAIN_ROLE"
            }, {
                "description": "Account Lead",
                "key": "ACCOUNT_LEAD"
            }, {
                "description": "Administrator",
                "key": "ADMIN"
            }, {
                "description": "Agent",
                "key": "AGENT"
            }, {
                "description": "Automated Agent",
                "key": "AUTOMATED_AGENT_ROLE"
            }, {
                "description": "Calendar",
                "key": "CALENDAR_ROLE"
            }, {
                "description": "Client",
                "key": "CLIENT"
            }, {
                "description": "Communication Participant",
                "key": "COMMEVENT_ROLE"
            }, {
                "description": "Consumer",
                "key": "CONSUMER"
            }, {
                "description": "Contractor",
                "key": "CONTRACTOR"
            }, {
                "description": "Customer",
                "key": "CUSTOMER"
            }, {
                "description": "Distribution Channel",
                "key": "DISTRIBUTION_CHANNEL"
            }, {
                "description": "ISP",
                "key": "ISP"
            }, {
                "description": "Hosting Server",
                "key": "HOSTING_SERVER"
            }, {
                "description": "Manufacturer",
                "key": "MANUFACTURER"
            }, {
                "description": "Not Applicable",
                "key": "_NA_"
            }, {
                "description": "Organization",
                "key": "ORGANIZATION_ROLE"
            }, {
                "description": "Owner",
                "key": "OWNER"
            }, {
                "description": "Prospect",
                "key": "PROSPECT"
            }, {
                "description": "Person",
                "key": "PERSON_ROLE"
            }, {
                "description": "Referrer",
                "key": "REFERRER"
            }, {
                "description": "Request Role",
                "key": "REQUEST_ROLE"
            }, {
                "description": "Request Manager",
                "key": "REQ_MANAGER"
            }, {
                "description": "Requesting Party",
                "key": "REQ_REQUESTER"
            }, {
                "description": "Request Taker",
                "key": "REQ_TAKER"
            }, {
                "description": "Request Respondent",
                "key": "REQ_RESPOND"
            }, {
                "description": "Sales Force Autm.",
                "key": "SFA_ROLE"
            }, {
                "description": "Shareholder",
                "key": "SHAREHOLDER"
            }, {
                "description": "Subscriber",
                "key": "SUBSCRIBER"
            }, {
                "description": "Vendor",
                "key": "VENDOR"
            }, {
                "description": "Visitor",
                "key": "VISITOR"
            }, {
                "description": "Web Master",
                "key": "WEB_MASTER"
            }, {
                "description": "Workflow",
                "key": "WORKFLOW_ROLE"
            }, {
                "description": "Accountant",
                "key": "ACCOUNTANT"
            }, {
                "description": "Account",
                "key": "ACCOUNT"
            }, {
                "description": "Addressee",
                "key": "ADDRESSEE"
            }, {
                "description": "Association",
                "key": "ASSOCIATION"
            }, {
                "description": "Bill-From-Vendor",
                "key": "BILL_FROM_VENDOR"
            }, {
                "description": "Bill-To Customer",
                "key": "BILL_TO_CUSTOMER"
            }, {
                "description": "Blind Copy",
                "key": "BCC"
            }, {
                "description": "Bulk Customer",
                "key": "BULK_CUSTOMER"
            }, {
                "description": "Calendar Attendee",
                "key": "CAL_ATTENDEE"
            }, {
                "description": "Calendar Delegate",
                "key": "CAL_DELEGATE"
            }, {
                "description": "Calendar Host",
                "key": "CAL_HOST"
            }, {
                "description": "Calendar Organizer",
                "key": "CAL_ORGANIZER"
            }, {
                "description": "Calendar Owner",
                "key": "CAL_OWNER"
            }, {
                "description": "Carrier",
                "key": "CARRIER"
            }, {
                "description": "Competitor",
                "key": "COMPETITOR"
            }, {
                "description": "Contact",
                "key": "CONTACT"
            }, {
                "description": "Carbon Copy",
                "key": "CC"
            }, {
                "description": "Originator",
                "key": "ORIGINATOR"
            }, {
                "description": "Distributor",
                "key": "DISTRIBUTOR"
            }, {
                "description": "Employee",
                "key": "EMPLOYEE"
            }, {
                "description": "Employer",
                "key": "EMPLOYER"
            }, {
                "description": "End-User Customer",
                "key": "END_USER_CUSTOMER"
            }, {
                "description": "Household",
                "key": "HOUSEHOLD"
            }, {
                "description": "Internal Organization",
                "key": "INTERNAL_ORGANIZATIO"
            }, {
                "description": "Lead",
                "key": "LEAD"
            }, {
                "description": "Limited Administrator",
                "key": "LTD_ADMIN"
            }, {
                "description": "Organization Unit",
                "key": "ORGANIZATION_UNIT"
            }, {
                "description": "Partner",
                "key": "PARTNER"
            }, {
                "description": "Placing Customer",
                "key": "PLACING_CUSTOMER"
            }, {
                "description": "Regulatory Agency",
                "key": "REGULATORY_AGENCY"
            }, {
                "description": "Sales Representative",
                "key": "SALES_REP"
            }, {
                "description": "Ship-From Vendor",
                "key": "SHIP_FROM_VENDOR"
            }, {
                "description": "Ship-To Customer",
                "key": "SHIP_TO_CUSTOMER"
            }, {
                "description": "Sponsor",
                "key": "SPONSOR"
            }, {
                "description": "Spouse",
                "key": "SPOUSE"
            }, {
                "description": "Supplier Agent",
                "key": "SUPPLIER_AGENT"
            }, {
                "description": "Supplier",
                "key": "SUPPLIER"
            }, {
                "description": "Tax Authority",
                "key": "TAX_AUTHORITY"
            }, {
                "description": "Union",
                "key": "UNION"
            }, {
                "description": "Workflow Owner",
                "key": "WF_OWNER"
            }, {
                "description": "Government Agency",
                "key": "GOV_AGENCY"
            }, {
                "description": "Affiliate",
                "key": "AFFILIATE"
            }, {
                "description": "Buyer",
                "key": "BUYER"
            }, {
                "description": "Cashier",
                "key": "CASHIER"
            }, {
                "description": "Department",
                "key": "DEPARTMENT"
            }, {
                "description": "Division",
                "key": "DIVISION"
            }, {
                "description": "Family Member",
                "key": "FAMILY_MEMBER"
            }, {
                "description": "Manager",
                "key": "MANAGER"
            }, {
                "description": "Order Clerk",
                "key": "ORDER_CLERK"
            }, {
                "description": "Other Internal",
                "key": "OTHER_INTERNAL_ORGAN"
            }, {
                "description": "Other Organization Unit",
                "key": "OTHER_ORGANIZATION_U"
            }, {
                "description": "Parent Organization",
                "key": "PARENT_ORGANIZATION"
            }, {
                "description": "Packer",
                "key": "PACKER"
            }, {
                "description": "Picker",
                "key": "PICKER"
            }, {
                "description": "Receiver",
                "key": "RECEIVER"
            }, {
                "description": "Shipment Clerk",
                "key": "SHIPMENT_CLERK"
            }, {
                "description": "Stocker",
                "key": "STOCKER"
            }, {
                "description": "Subsidiary",
                "key": "SUBSIDIARY"
            }, {
                "description": "Worker",
                "key": "WORKER"
            }, {
                "description": "Email Administrator",
                "key": "EMAIL_ADMIN"
            }, {
                "description": "Image Approver",
                "key": "IMAGEAPPROVER"
            }, {
                "description": "Logged In",
                "key": "LOGGEDIN"
            }, {
                "description": "Content Member",
                "key": "CONTENT"
            }, {
                "description": "Content Administrator",
                "key": "CONTENT_ADMIN"
            }, {
                "description": "Content Publisher",
                "key": "CONTENT_PUBLISHER"
            }, {
                "description": "Content Editor",
                "key": "CONTENT_EDITOR"
            }, {
                "description": "Content Author",
                "key": "CONTENT_AUTHOR"
            }, {
                "description": "Content User",
                "key": "CONTENT_USER"
            }, {
                "description": "Content Guest",
                "key": "CONTENT_GUEST"
            }, {
                "description": "Calendar Member",
                "key": "ICAL_MEMBER"
            }, {
                "description": "Budget Roles Group (not to be assigned to parties)",
                "key": "BUDGET"
            }, {
                "description": "Budget Application",
                "key": "BUDGET_APPL"
            }, {
                "description": "Budget Manager",
                "key": "BUDGET_MGR"
            }, {
                "description": "Budget Reviewer",
                "key": "BUDGET_RVR"
            }, {
                "description": "Budget Approver",
                "key": "BUDGET_APPRV"
            }, {
                "description": "Fixed Asset Maint Assignee",
                "key": "FAM_ASSIGNEE"
            }, {
                "description": "Maintenance Supplier or Service",
                "key": "FAM_SUPPLIER"
            }, {
                "description": "Maintenance Manager or Supervisor",
                "key": "FAM_MANAGER"
            }, {
                "description": "Maintenance Worker",
                "key": "FAM_WORKER"
            }, {
                "description": "Project Team",
                "key": "PROJECT_TEAM"
            }, {
                "description": "Client Manager",
                "key": "CLIENT_MANAGER"
            }, {
                "description": "Client Analyst",
                "key": "CLIENT_ANALYST"
            }, {
                "description": "Client Billing",
                "key": "CLIENT_BILLING"
            }, {
                "description": "Provider Manager",
                "key": "PROVIDER_MANAGER"
            }, {
                "description": "Provider Accounting",
                "key": "PROVIDER_ACCOUNTING"
            }, {
                "description": "Provider Analyst",
                "key": "PROVIDER_ANALYST"
            }, {
                "description": "Provider Validator",
                "key": "PROVIDER_VALIDATOR"
            }, {
                "description": "Provider Functional",
                "key": "PROVIDER_FUNCTIONAL"
            }, {
                "description": "Provider Tester",
                "key": "PROVIDER_TESTER"
            }, {
                "description": "Scrum Member",
                "key": "SCRUM_MEMBER"
            }, {
                "description": "Product Owner",
                "key": "PRODUCT_OWNER"
            }, {
                "description": "SCRUM Master",
                "key": "SCRUM_MASTER"
            }, {
                "description": "SCRUM Team",
                "key": "SCRUM_TEAM"
            }, {
                "description": "Product Owner Company",
                "key": "PRODUCT_OWNER_COMP"
            }, {
                "description": "Stakeholder",
                "key": "STAKEHOLDER"
            }, {
                "description": "Approver",
                "key": "APPROVER"
            }, {
                "description": "Reviewer",
                "key": "REVIEWER"
            }],
            "disabled": "false",
            "id": "EditProductStoreRole_roleTypeId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "roleTypeId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "",
            "title": "From Date",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-14%2018:02:07.309",
            "timeDropdown": "text",
            "alert": "false",
            "timeValues": "",
            "formName": "EditProductStoreRole",
            "timeDropdownParamName": "fromDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "EditProductStoreRole_fromDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "fromDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "",
            "title": "Through Date",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-14%2018:02:07.31",
            "timeDropdown": "text",
            "alert": "false",
            "timeValues": "",
            "formName": "EditProductStoreRole",
            "timeDropdownParamName": "thruDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "EditProductStoreRole_thruDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "thruDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Sequence Num",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "sequenceNum",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreRole_sequenceNum",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "EditProductStoreRole",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "EditProductStoreRole_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Add",
            "event": "",
            "imgSrc": ""
        }],
        "target": "storeUpdateRole"
    },
    {
        "columns": [{
            "name": "productPromoId",
            "title": "Product Promo ID"
        }, {
            "name": "promoName",
            "title": "Promo Name"
        }, {
            "name": "fromDate",
            "title": "From Date"
        }, {
            "name": "thruDate",
            "title": "Through Date"
        }, {
            "name": "sequenceNum",
            "title": "Sequence Num"
        }, {
            "name": "manualOnly",
            "title": "Manual Only"
        }, {
            "name": "submitButton",
            "title": "Update"
        }],
        "formName": "ListProductStorePromos",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "ListProductStorePromos_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "image": "",
            "fieldHelpText": "",
            "alternate": "",
            "description": "",
            "title": "Product Promo ID",
            "type": "HYPERLINK",
            "target": "EditProductPromo",
            "name": "productPromoId",
            "width": "",
            "parameterList": [{
                "name": "productPromoId"
            }],
            "style": "",
            "id": "ListProductStorePromos_productPromoId",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "formData": {
                "formName": "EditProductPromo",
                "formLocation": ""
            },
            "event": "edit"
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "promoName",
            "description": "",
            "style": "",
            "id": "ListProductStorePromos_promoName",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "fromDate",
            "description": "",
            "style": "",
            "id": "ListProductStorePromos_fromDate",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "",
            "title": "Through Date",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-14%2018:03:45.94",
            "timeDropdown": "text",
            "alert": "false",
            "timeValues": "",
            "formName": "ListProductStorePromos",
            "timeDropdownParamName": "thruDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "ListProductStorePromos_thruDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "thruDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Sequence Num",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "sequenceNum",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "ListProductStorePromos_sequenceNum",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Manual Only",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "ListProductStorePromos",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "ListProductStorePromos_manualOnly",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "manualOnly",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "ListProductStorePromos",
            "tabindex": "",
            "name": "submitButton",
            "className": "",
            "id": "ListProductStorePromos_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Update",
            "event": "",
            "imgSrc": ""
        }],
        "target": "updateProductStorePromoAppl"
    },
    {
        "formName": "CreateProductStorePromo",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "CreateProductStorePromo_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Product Promo ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "CreateProductStorePromo",
            "options": [{
                "description": "[9000] Test Promo 1",
                "key": "9000"
            }, {
                "description": "[9010] Test Percent off product set ",
                "key": "9010"
            }, {
                "description": "[9011] Test percent off entire purchase, no condition",
                "key": "9011"
            }, {
                "description": "[9012] Test amount off order",
                "key": "9012"
            }, {
                "description": "[9013] Test buy X get Y free",
                "key": "9013"
            }, {
                "description": "[9014] Test buy X get Y at Z% discount",
                "key": "9014"
            }, {
                "description": "[9015] Test X products for $Y",
                "key": "9015"
            }, {
                "description": "[9016] Test $ off products in categories",
                "key": "9016"
            }, {
                "description": "[9017] Test Gift with Amount of Specific Product",
                "key": "9017"
            }, {
                "description": "[9018] Test Gift with Total Amount of Product",
                "key": "9018"
            }, {
                "description": "[9019] Test Percent off when Customer Orders over $1000 in 12 months",
                "key": "9019"
            }, {
                "description": "[9020] Test Promotion Recurrence - Happy hour",
                "key": "9020"
            }, {
                "description": "[9022] Free Shipping in Utah",
                "key": "9022"
            }, {
                "description": "[9021] Test Products for Special Promo Price",
                "key": "9021"
            }],
            "disabled": "false",
            "id": "CreateProductStorePromo_productPromoId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "productPromoId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "required",
            "title": "From Date",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-14%2018:04:56.938",
            "timeDropdown": "text",
            "alert": "false",
            "timeValues": "",
            "formName": "CreateProductStorePromo",
            "timeDropdownParamName": "fromDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "CreateProductStorePromo_fromDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "fromDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "",
            "title": "Through Date",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-14%2018:04:56.938",
            "timeDropdown": "text",
            "alert": "false",
            "timeValues": "",
            "formName": "CreateProductStorePromo",
            "timeDropdownParamName": "thruDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "CreateProductStorePromo_thruDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "thruDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Manual Only",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "CreateProductStorePromo",
            "options": [{
                "description": "N",
                "key": "N"
            }, {
                "description": "Y",
                "key": "Y"
            }],
            "disabled": "false",
            "id": "CreateProductStorePromo_manualOnly",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "manualOnly",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "CreateProductStorePromo",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "CreateProductStorePromo_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Add",
            "event": "",
            "imgSrc": ""
        }],
        "target": "createProductStorePromoAppl"
    },
    {
        "columns": [{
            "name": "productStoreId",
            "title": "Product Store ID"
        }, {
            "name": "prodCatalogId",
            "title": "Catalog [ID]"
        }, {
            "name": "fromDate",
            "title": "From Date  Time"
        }, {
            "name": "thruDate",
            "title": "Through Date  Time"
        }, {
            "name": "sequenceNum",
            "title": "Sequence Num"
        }, {
            "name": "submitButton",
            "title": "Update"
        }, {
            "name": "deleteLink",
            "title": " "
        }],
        "formName": "UpdateProductStoreCatalog",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "": "",
            "fieldHelpText": "",
            "textSize": "20",
            "ajaxUrl": "",
            "maxlength": "20",
            "tabindex": "",
            "className": "",
            "title": "Product Store ID",
            "type": "HIDDEN",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "productStoreId",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "UpdateProductStoreCatalog_productStoreId",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "hyperlink": {
                "linkStyle": "buttontext",
                "description": "",
                "targetType": "intra-app",
                "confirmation": "",
                "parameterMap": {
                    "VIEW_SIZE_0": "20",
                    "VIEW_INDEX_0": "0"
                },
                "uniqueItemName": "Modal_0529cdd2_cfa3_489d_b2ac_e9d8a288b37d",
                "target": "EditProdCatalog",
                "targetWindow": "",
                "remoteFormData": {
                    "formData": {
                        "formName": "EditProdCatalog",
                        "formLocation": "component://kwikstore/widget/ProdCatalogForms.xml",
                        "link": "/admin/catalogs/catalog/${prodCatalogId}"
                    }
                }
            },
            "event": "edit",
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "prodCatalogId",
            "description": "",
            "style": "",
            "id": "UpdateProductStoreCatalog_prodCatalogId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "fromDate",
            "description": "",
            "style": "",
            "id": "UpdateProductStoreCatalog_fromDate",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "",
            "title": "Through Date  Time",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-14%2018:06:23.401",
            "timeDropdown": "",
            "alert": "false",
            "timeValues": "",
            "formName": "UpdateProductStoreCatalog",
            "timeDropdownParamName": "thruDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "UpdateProductStoreCatalog_thruDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "thruDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Sequence Num",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "sequenceNum",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "UpdateProductStoreCatalog_sequenceNum",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "UpdateProductStoreCatalog",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "UpdateProductStoreCatalog_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Update",
            "event": "",
            "imgSrc": ""
        }, {
            "image": "",
            "width": "",
            "name": "deleteLink",
            "alternate": "",
            "description": "Delete",
            "parameterList": [{
                "name": "prodCatalogId"
            }, {
                "name": "productStoreId"
            }, {
                "name": "fromDate"
            }],
            "id": "UpdateProductStoreCatalog_deleteLink",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "target": "deleteProductStoreCatalog"
        }],
        "target": "updateProductStoreCatalog"
    },
    {
        "formName": "CreateProductStoreCatalog",
        "altTarget": [],
        "targets": {
            "createTarget": "createProductStoreCatalog"
        },
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "CreateProductStoreCatalog_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Catalog",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "CreateProductStoreCatalog",
            "options": [{
                "description": "Demo Catalog",
                "key": "DemoCatalog"
            }, {
                "description": "Google Catalog",
                "key": "GoogleCatalog"
            }, {
                "description": "Rental Catalog",
                "key": "RentalCatalog"
            }, {
                "description": "Test Catalog",
                "key": "TestCatalog"
            }, {
                "description": "eBay Catalog",
                "key": "eBayCatalog"
            }],
            "disabled": "false",
            "id": "CreateProductStoreCatalog_prodCatalogId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "prodCatalogId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "",
            "title": "From Date",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-14%2018:07:40.271",
            "timeDropdown": "",
            "alert": "false",
            "timeValues": "",
            "formName": "CreateProductStoreCatalog",
            "timeDropdownParamName": "fromDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "CreateProductStoreCatalog_fromDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "fromDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "",
            "title": "Through Date",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-14%2018:07:40.271",
            "timeDropdown": "",
            "alert": "false",
            "timeValues": "",
            "formName": "CreateProductStoreCatalog",
            "timeDropdownParamName": "thruDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "CreateProductStoreCatalog_thruDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "thruDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Sequence Num",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "sequenceNum",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "CreateProductStoreCatalog_sequenceNum",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "CreateProductStoreCatalog",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "CreateProductStoreCatalog_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Add",
            "event": "",
            "imgSrc": ""
        }],
        "target": "createProductStoreCatalog"
    },
    {
        "columns": [{
            "name": "webSiteId",
            "title": "WebSite [ID]"
        }, {
            "name": "httpHost",
            "title": "Host"
        }, {
            "name": "httpPort",
            "title": "Port"
        }, {
            "name": "deleteLink",
            "title": " "
        }],
        "formName": "EditProductStoreWebSites",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "EditProductStoreWebSites_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "image": "",
            "fieldHelpText": "",
            "alternate": "",
            "description": " []",
            "title": "WebSite [ID]",
            "type": "HYPERLINK",
            "target": "EditWebSite",
            "name": "webSiteId",
            "width": "",
            "parameterList": [{
                "name": "webSiteId"
            }],
            "style": "",
            "id": "EditProductStoreWebSites_webSiteId",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "formData": {
                "formName": "EditWebSite",
                "formLocation": "component://kwikstore/widget/StoreForms.xml"
            },
            "event": "edit"
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "httpHost",
            "description": "",
            "style": "",
            "id": "EditProductStoreWebSites_httpHost",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "httpPort",
            "description": "",
            "style": "",
            "id": "EditProductStoreWebSites_httpPort",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "image": "",
            "width": "",
            "name": "deleteLink",
            "alternate": "",
            "description": "Remove",
            "parameterList": [{
                "name": "viewProductStoreId",
                "value": {
                    "chars": "${productStoreId}",
                    "hint": 20,
                    "offset": 0,
                    "length": 17,
                    "bracketedOriginal": "${productStoreId}",
                    "empty": false,
                    "original": "${productStoreId}"
                }
            }, {
                "name": "productStoreId"
            }, {
                "name": "webSiteId",
                "value": {
                    "chars": "${webSite.webSiteId}",
                    "hint": 20,
                    "offset": 0,
                    "length": 20,
                    "bracketedOriginal": "${webSite.webSiteId}",
                    "empty": false,
                    "original": "${webSite.webSiteId}"
                }
            }],
            "id": "EditProductStoreWebSites_deleteLink",
            "imageTitle": "",
            "parameterMap": {
                "viewProductStoreId": "",
                "webSiteId": ""
            },
            "height": "",
            "target": "removeAgreementItem"
        }],
        "target": "storeUpdateWebSite"
    },
    {
        "formName": "SetProductStoreOnWebSite",
        "altTarget": [],
        "targets": {
            "createTarget": "storeUpdateWebSite"
        },
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "viewProductStoreId",
            "action": "",
            "id": "SetProductStoreOnWebSite_viewProductStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "SetProductStoreOnWebSite_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Web Site",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "SetProductStoreOnWebSite",
            "options": [{
                "description": "",
                "key": "CmsSite"
            }, {
                "description": "",
                "key": "WebStoreClone"
            }, {
                "description": "",
                "key": "OfbizSite"
            }, {
                "description": "",
                "key": "OpenTravelSystem"
            }, {
                "description": "",
                "key": "WebStorePos"
            }, {
                "description": "",
                "key": "WebSite1"
            }, {
                "description": "",
                "key": "WebSite2"
            }, {
                "description": "",
                "key": "EBAY"
            }, {
                "description": "",
                "key": "WebStore"
            }],
            "disabled": "false",
            "id": "SetProductStoreOnWebSite_webSiteId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "webSiteId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "SetProductStoreOnWebSite",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "SetProductStoreOnWebSite_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Create",
            "event": "",
            "imgSrc": ""
        }],
        "target": "storeUpdateWebSite"
    },
    {
        "columns": [{
            "name": "productStoreShipMethId",
            "title": " "
        }, {
            "name": "shipmentMethodTypeId",
            "title": "Method"
        }, {
            "name": "partyId",
            "title": "Party ID"
        }, {
            "name": "companyPartyId",
            "title": "Comp. Party ID"
        }, {
            "name": "minWeight",
            "title": "Min Wt."
        }, {
            "name": "maxWeight",
            "title": "Max Wt."
        }, {
            "name": "minSize",
            "title": "Min Size"
        }, {
            "name": "maxSize",
            "title": "Max Size"
        }, {
            "name": "minTotal",
            "title": "Min Tot."
        }, {
            "name": "maxTotal",
            "title": "Max Tot."
        }, {
            "name": "allowUspsAddr",
            "title": "Allow USPS Addr"
        }, {
            "name": "requireUspsAddr",
            "title": "Req. USPS Addr"
        }, {
            "name": "allowCompanyAddr",
            "title": "Allow Comp. Addr"
        }, {
            "name": "requireCompanyAddr",
            "title": "Req. Comp. Addr"
        }, {
            "name": "includeNoChargeItems",
            "title": "Incl. No Charge Items"
        }, {
            "name": "includeFeatureGroup",
            "title": "Incl. Feat. Group"
        }, {
            "name": "excludeFeatureGroup",
            "title": "Excl. Feat. Group"
        }, {
            "name": "includeGeoId",
            "title": "Incl. Geo ID"
        }, {
            "name": "excludeGeoId",
            "title": "Excl. Geo ID"
        }, {
            "name": "serviceName",
            "title": "Shipment Service Name (deprecated use)"
        }, {
            "name": "configProps",
            "title": "Config Properties (deprecated use)"
        }, {
            "name": "shipmentCustomMethodId",
            "title": "Shipment Custom Method"
        }, {
            "name": "shipmentGatewayConfigId",
            "title": "Shipment Gateway Config ID"
        }, {
            "name": "sequenceNumber",
            "title": "Seq. Num."
        }, {
            "name": "allowancePercent",
            "title": "Allowance Percent"
        }, {
            "name": "minimumPrice",
            "title": "Minimum Price"
        }, {
            "name": "deleteLink",
            "title": " "
        }],
        "formName": "ListProductStoreShipmentMeths",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "ListProductStoreShipmentMeths_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "roleTypeId",
            "action": "",
            "id": "ListProductStoreShipmentMeths_roleTypeId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "image": "",
            "width": "",
            "name": "productStoreShipMethId",
            "alternate": "",
            "description": "",
            "parameterList": [{
                "name": "productStoreId"
            }, {
                "name": "productStoreShipMethId"
            }],
            "id": "ListProductStoreShipmentMeths_productStoreShipMethId",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "target": "EditProductStoreShipSetup"
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "shipmentMethodTypeId",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_shipmentMethodTypeId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "partyId",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_partyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "companyPartyId",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_companyPartyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "minWeight",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_minWeight",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "maxWeight",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_maxWeight",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "minSize",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_minSize",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "maxSize",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_maxSize",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "minTotal",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_minTotal",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "maxTotal",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_maxTotal",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "allowUspsAddr",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_allowUspsAddr",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "requireUspsAddr",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_requireUspsAddr",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "allowCompanyAddr",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_allowCompanyAddr",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "requireCompanyAddr",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_requireCompanyAddr",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "includeNoChargeItems",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_includeNoChargeItems",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "includeFeatureGroup",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_includeFeatureGroup",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "excludeFeatureGroup",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_excludeFeatureGroup",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "includeGeoId",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_includeGeoId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "excludeGeoId",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_excludeGeoId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "serviceName",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_serviceName",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "configProps",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_configProps",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "shipmentCustomMethodId",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_shipmentCustomMethodId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "shipmentGatewayConfigId",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_shipmentGatewayConfigId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "sequenceNumber",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_sequenceNumber",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "allowancePercent",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_allowancePercent",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "minimumPrice",
            "description": "",
            "style": "",
            "id": "ListProductStoreShipmentMeths_minimumPrice",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "image": "",
            "width": "",
            "name": "deleteLink",
            "alternate": "",
            "description": "Remove",
            "parameterList": [{
                "name": "productStoreId"
            }, {
                "name": "productStoreShipMethId"
            }],
            "id": "ListProductStoreShipmentMeths_deleteLink",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "target": "storeRemoveShipMeth"
        }],
        "target": ""
    },
    {
        "formName": "EditProductStoreShipmentMeth",
        "altTarget": [{
            "useWhen": "productStoreShipmentMeth==null",
            "targetExdr": {
                "chars": "storeCreateShipMeth",
                "hint": 20,
                "empty": false,
                "original": "storeCreateShipMeth"
            }
        }],
        "targets": {
            "createTarget": "storeCreateShipMeth",
            "updateTarget": "storeUpdateShipMeth"
        },
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "EditProductStoreShipmentMeth_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "shipmentMethodTypeId",
            "action": "",
            "id": "EditProductStoreShipmentMeth_shipmentMethodTypeId",
            "type": "DISPLAY_ENTITY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "roleTypeId",
            "action": "",
            "id": "EditProductStoreShipmentMeth_roleTypeId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "partyId",
            "action": "",
            "id": "EditProductStoreShipmentMeth_partyId",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "shipmentMethodTypeId",
            "description": "",
            "style": "",
            "id": "EditProductStoreShipmentMeth_shipmentMethodTypeId",
            "title": "Shipment Method TypeId",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "roleTypeId",
            "description": "",
            "style": "",
            "id": "EditProductStoreShipmentMeth_roleTypeId",
            "title": "Role TypeId",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "partyId",
            "description": "",
            "style": "",
            "id": "EditProductStoreShipmentMeth_partyId",
            "title": "Party ID",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Min Size",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "minSize",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_minSize",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Max Size",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "maxSize",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_maxSize",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Min Wt.",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "minWeight",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_minWeight",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Max Wt.",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "maxWeight",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_maxWeight",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Min Tot.",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "minTotal",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_minTotal",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Max Tot.",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "maxTotal",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_maxTotal",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Allow USPS Addr",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreShipmentMeth",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStoreShipmentMeth_allowUspsAddr",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "allowUspsAddr",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Req. USPS Addr",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreShipmentMeth",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStoreShipmentMeth_requireUspsAddr",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "requireUspsAddr",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Allow Comp. Addr",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreShipmentMeth",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStoreShipmentMeth_allowCompanyAddr",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "allowCompanyAddr",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Req. Comp. Addr",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "N",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreShipmentMeth",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStoreShipmentMeth_requireCompanyAddr",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "requireCompanyAddr",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStoreShipmentMeth",
                "id": "EditProductStoreShipmentMeth_companyPartyId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupPartyName",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "companyPartyId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "companyPartyId",
            "style": "",
            "id": "EditProductStoreShipmentMeth_companyPartyId",
            "title": "Comp. Party ID",
            "type": "LOOKUP"
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Include Free Ship Items",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "Y",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreShipmentMeth",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStoreShipmentMeth_includeNoChargeItems",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "includeNoChargeItems",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStoreShipmentMeth",
                "id": "EditProductStoreShipmentMeth_includeGeoId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupGeo",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "includeGeoId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "includeGeoId",
            "style": "",
            "id": "EditProductStoreShipmentMeth_includeGeoId",
            "title": "Include Geo",
            "type": "LOOKUP"
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStoreShipmentMeth",
                "id": "EditProductStoreShipmentMeth_excludeGeoId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupGeo",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "excludeGeoId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "excludeGeoId",
            "style": "",
            "id": "EditProductStoreShipmentMeth_excludeGeoId",
            "title": "Exclude Geo",
            "type": "LOOKUP"
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Include Feature Group",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "includeFeatureGroup",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_includeFeatureGroup",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Exclude Feature Group",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "excludeFeatureGroup",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_excludeFeatureGroup",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Shipment Service Name (deprecated use)",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "serviceName",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_serviceName",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Config Properties (deprecated use)",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "configProps",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_configProps",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Shipment Custom Method",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreShipmentMeth",
            "options": [{
                "description": "DHL rate estimate (dhlRateEstimate)",
                "key": "SHIP_EST_DHL"
            }, {
                "description": "FedEx rate estimate (fedexRateEstimate)",
                "key": "SHIP_EST_FEDEX"
            }, {
                "description": "UPS rate estimate (upsRateEstimate)",
                "key": "SHIP_EST_UPS"
            }, {
                "description": "USPS rate estimate (uspsRateInquire)",
                "key": "SHIP_EST_USPS"
            }, {
                "description": "USPS rate estimate international (uspsInternationalRateInquire)",
                "key": "SHIP_EST_USPS_INT"
            }],
            "disabled": "false",
            "id": "EditProductStoreShipmentMeth_shipmentCustomMethodId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "shipmentCustomMethodId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Shipment Gateway Config ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreShipmentMeth",
            "options": [{
                "description": "DHL Config",
                "key": "DHL_CONFIG"
            }, {
                "description": "Fedex Config",
                "key": "FEDEX_CONFIG"
            }, {
                "description": "UPS Config",
                "key": "UPS_CONFIG"
            }, {
                "description": "USPS Config",
                "key": "USPS_CONFIG"
            }],
            "disabled": "false",
            "id": "EditProductStoreShipmentMeth_shipmentGatewayConfigId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "shipmentGatewayConfigId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Sequence Num",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "sequenceNumber",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreShipmentMeth_sequenceNumber",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "EditProductStoreShipmentMeth",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "EditProductStoreShipmentMeth_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Submit",
            "event": "",
            "imgSrc": ""
        }],
        "target": "storeUpdateShipMeth"
    },
    {
        "columns": [{
            "name": "shipmentCostEstimateId",
            "title": " "
        }, {
            "name": "shipmentMethodTypeId",
            "title": "Method"
        }, {
            "name": "carrierPartyId",
            "title": "Carrier Party ID"
        }, {
            "name": "productStoreShipMethId",
            "title": "Product Store Ship Meth ID"
        }, {
            "name": "partyId",
            "title": "Party ID"
        }, {
            "name": "roleTypeId",
            "title": "Role Type ID"
        }, {
            "name": "geoIdTo",
            "title": "To Geo"
        }, {
            "name": "geoIdFrom",
            "title": "From Geo"
        }, {
            "name": "weightBreakId",
            "title": "Weight Break ID"
        }, {
            "name": "weightUomId",
            "title": "Unit Of Measure"
        }, {
            "name": "weightUnitPrice",
            "title": "Weight Unit Price"
        }, {
            "name": "quantityBreakId",
            "title": "Quantity Break ID"
        }, {
            "name": "quantityUomId",
            "title": "Unit Of Measure"
        }, {
            "name": "quantityUnitPrice",
            "title": "Quantity Unit Price"
        }, {
            "name": "priceBreakId",
            "title": "Price Break ID"
        }, {
            "name": "priceUomId",
            "title": "Unit Of Measure"
        }, {
            "name": "priceUnitPrice",
            "title": "Price Unit Price"
        }, {
            "name": "orderFlatPrice",
            "title": "Order Flat Price"
        }, {
            "name": "orderPricePercent",
            "title": "Order Price Percent"
        }, {
            "name": "orderItemFlatPrice",
            "title": "Order Item Flat Price"
        }, {
            "name": "shippingPricePercent",
            "title": "Shipping Price Percent"
        }, {
            "name": "productFeatureGroupId",
            "title": "Product Feature Group ID"
        }, {
            "name": "oversizeUnit",
            "title": "Oversize Unit"
        }, {
            "name": "oversizePrice",
            "title": "Oversize Price"
        }, {
            "name": "featurePercent",
            "title": "Feature Percent"
        }, {
            "name": "featurePrice",
            "title": "Feature Price"
        }, {
            "name": "deleteLink",
            "title": " "
        }],
        "formName": "ListShipmentCostEstimates",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "carrierRoleTypeId",
            "action": "",
            "id": "ListShipmentCostEstimates_carrierRoleTypeId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "ListShipmentCostEstimates_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "image": "",
            "width": "",
            "name": "shipmentCostEstimateId",
            "alternate": "",
            "description": "",
            "parameterList": [{
                "name": "productStoreId"
            }, {
                "name": "shipmentCostEstimateId"
            }],
            "id": "ListShipmentCostEstimates_shipmentCostEstimateId",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "target": "EditProductStoreShipmentCostEstimates"
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "shipmentMethodTypeId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_shipmentMethodTypeId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "carrierPartyId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_carrierPartyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "productStoreShipMethId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_productStoreShipMethId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "partyId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_partyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "roleTypeId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_roleTypeId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "geoIdTo",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_geoIdTo",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "geoIdFrom",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_geoIdFrom",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "weightBreakId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_weightBreakId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "weightUomId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_weightUomId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "weightUnitPrice",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_weightUnitPrice",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "quantityBreakId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_quantityBreakId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "quantityUomId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_quantityUomId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "quantityUnitPrice",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_quantityUnitPrice",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "priceBreakId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_priceBreakId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "priceUomId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_priceUomId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "priceUnitPrice",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_priceUnitPrice",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "orderFlatPrice",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_orderFlatPrice",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "orderPricePercent",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_orderPricePercent",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "orderItemFlatPrice",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_orderItemFlatPrice",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "shippingPricePercent",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_shippingPricePercent",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "productFeatureGroupId",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_productFeatureGroupId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "oversizeUnit",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_oversizeUnit",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "oversizePrice",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_oversizePrice",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "featurePercent",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_featurePercent",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "featurePrice",
            "description": "",
            "style": "",
            "id": "ListShipmentCostEstimates_featurePrice",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "image": "",
            "width": "",
            "name": "deleteLink",
            "alternate": "",
            "description": "Remove",
            "parameterList": [{
                "name": "productStoreId"
            }, {
                "name": "shipmentCostEstimateId"
            }],
            "id": "ListShipmentCostEstimates_deleteLink",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "target": "storeRemoveShipRate"
        }],
        "target": ""
    },
    {
        "fieldSets": [{
            "fieldSetName": "Default",
            "fields": ["productStoreShipMethId", "fromGeo", "toGeo", "partyId", "roleTypeId", "flatPercent"]
        }, {
            "fieldSetName": "Flat charges",
            "fields": ["flatPrice", "flatItemPrice", "shippingPricePercent", "productFeatureGroupId"]
        }, {
            "fieldSetName": "Features group charges",
            "fields": ["featurePercent", "featurePrice", "oversizeUnit"]
        }, {
            "fieldSetName": "Oversize surcharge",
            "fields": ["oversizePrice", "WeightTitle2"]
        }, {
            "fieldSetName": "Weight charge",
            "fields": ["wmin", "wmax", "weightBreakId", "wuom", "wprice", "QuantityTitle2"]
        }, {
            "fieldSetName": "Quantity charge",
            "fields": ["qmin", "qmax", "quantityBreakId", "quom", "qprice", "PriceTitle2"]
        }, {
            "fieldSetName": "Price charge",
            "fields": ["pmin", "pmax", "priceBreakId", "puom", "pprice", "submitButton"]
        }],
        "formName": "AddShipmentCostEstimate",
        "altTarget": [],
        "targets": {
            "createTarget": "storeCreateShipRate"
        },
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "AddShipmentCostEstimate_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Shipment Method",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "AddShipmentCostEstimate",
            "options": [],
            "disabled": "false",
            "id": "AddShipmentCostEstimate_productStoreShipMethId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "productStoreShipMethId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "AddShipmentCostEstimate",
                "id": "AddShipmentCostEstimate_fromGeo",
                "event": "",
                "value": "",
                "fieldFormName": "LookupGeo",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "fromGeo",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "fromGeo",
            "style": "",
            "id": "AddShipmentCostEstimate_fromGeo",
            "title": "From Geo",
            "type": "LOOKUP"
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "AddShipmentCostEstimate",
                "id": "AddShipmentCostEstimate_toGeo",
                "event": "",
                "value": "",
                "fieldFormName": "LookupGeo",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "toGeo",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "toGeo",
            "style": "",
            "id": "AddShipmentCostEstimate_toGeo",
            "title": "To Geo",
            "type": "LOOKUP"
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Party ID",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "partyId",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_partyId",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Role Type ID",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "roleTypeId",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_roleTypeId",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Flat Base Percent",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "flatPercent",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_flatPercent",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Flat Base Price",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "flatPrice",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_flatPrice",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Flat Item Price",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "flatItemPrice",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_flatItemPrice",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Flat Shipping Percent",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "shippingPricePercent",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_shippingPricePercent",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Feature Group",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "productFeatureGroupId",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_productFeatureGroupId",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Per-Feature Percent",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "featurePercent",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_featurePercent",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Per-Feature Price",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "featurePrice",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_featurePrice",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Oversize Unit",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "oversizeUnit",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_oversizeUnit",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Oversize Surcharge",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "oversizePrice",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_oversizePrice",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "ajaxEnabled": false,
            "size": 0,
            "name": "WeightTitle2",
            "description": " ",
            "id": "AddShipmentCostEstimate_WeightTitle2",
            "type": "DISPLAY",
            "title": "",
            "imageLocation": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Min Wt",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "wmin",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_wmin",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Max Wt",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "wmax",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_wmax",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Weight Break ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "AddShipmentCostEstimate",
            "options": [{
                "description": "0 - 0",
                "key": "RentalStore"
            }, {
                "description": "0 - 0",
                "key": "9003"
            }, {
                "description": "0 - 0",
                "key": "9009"
            }, {
                "description": "0 - 0",
                "key": "9000"
            }, {
                "description": "0 - 0",
                "key": "9001"
            }, {
                "description": "0 - 0",
                "key": "9002"
            }, {
                "description": "0 - 0",
                "key": "9004"
            }, {
                "description": "0 - 0",
                "key": "9005"
            }, {
                "description": "0 - 0",
                "key": "9006"
            }, {
                "description": "0 - 0",
                "key": "9007"
            }, {
                "description": "0 - 0",
                "key": "9008"
            }, {
                "description": "0 - 0",
                "key": "9100"
            }, {
                "description": "0 - 0",
                "key": "9101"
            }, {
                "description": "0 - 0",
                "key": "9102"
            }, {
                "description": "0 - 0",
                "key": "9103"
            }, {
                "description": "0 - 0",
                "key": "9104"
            }, {
                "description": "0 - 0",
                "key": "9105"
            }, {
                "description": "0 - 0",
                "key": "9106"
            }, {
                "description": "0 - 0",
                "key": "9107"
            }, {
                "description": "0 - 0",
                "key": "9108"
            }, {
                "description": "0 - 0",
                "key": "9109"
            }],
            "disabled": "false",
            "id": "AddShipmentCostEstimate_weightBreakId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "weightBreakId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Unit Of Measure",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "AddShipmentCostEstimate",
            "options": [{
                "description": "Dram (avdp)",
                "key": "WT_dr_avdp"
            }, {
                "description": "Grain",
                "key": "WT_gr"
            }, {
                "description": "Gram",
                "key": "WT_g"
            }, {
                "description": "Kilogram",
                "key": "WT_kg"
            }, {
                "description": "Milligram",
                "key": "WT_mg"
            }, {
                "description": "Ounce (avdp)",
                "key": "WT_oz"
            }, {
                "description": "Ounce (troy)",
                "key": "WT_oz_tr"
            }, {
                "description": "Pennyweight",
                "key": "WT_dwt"
            }, {
                "description": "Pound (avdp)",
                "key": "WT_lb"
            }, {
                "description": "Stone",
                "key": "WT_st"
            }, {
                "description": "Ton (long or British)",
                "key": "WT_lt"
            }, {
                "description": "Ton (metric)",
                "key": "WT_mt"
            }, {
                "description": "Ton (short)",
                "key": "WT_sh_t"
            }],
            "disabled": "false",
            "id": "AddShipmentCostEstimate_wuom",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "wuom",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Per Unit Price",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "wprice",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_wprice",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "ajaxEnabled": false,
            "size": 0,
            "name": "QuantityTitle2",
            "description": " ",
            "id": "AddShipmentCostEstimate_QuantityTitle2",
            "type": "DISPLAY",
            "title": "",
            "imageLocation": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Min Qt",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "qmin",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_qmin",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Max Qt",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "qmax",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_qmax",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Quantity Break ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "AddShipmentCostEstimate",
            "options": [],
            "disabled": "false",
            "id": "AddShipmentCostEstimate_quantityBreakId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "quantityBreakId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Unit Of Measure",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "AddShipmentCostEstimate",
            "options": [{
                "description": "Acre",
                "key": "AREA_A"
            }, {
                "description": "Amphere - Electric current",
                "key": "OTH_A"
            }, {
                "description": "Angstrom",
                "key": "LEN_A"
            }, {
                "description": "Are",
                "key": "AREA_a"
            }, {
                "description": "Barrel (US)",
                "key": "VLIQ_bbl"
            }, {
                "description": "Bit of Data",
                "key": "DATA_b"
            }, {
                "description": "Bit-per-second of Data",
                "key": "DATASPD_bps"
            }, {
                "description": "Box",
                "key": "OTH_box"
            }, {
                "description": "British Thermal Unit",
                "key": "EN_Btu"
            }, {
                "description": "Byte of Data",
                "key": "DATA_B"
            }, {
                "description": "Cable",
                "key": "LEN_cb"
            }, {
                "description": "Calorie (@15.5c)",
                "key": "EN_cal15"
            }, {
                "description": "Candela - Luminosity (intensity of light)",
                "key": "OTH_cd"
            }, {
                "description": "Centimeter",
                "key": "LEN_cm"
            }, {
                "description": "Chain (Gunter\\'s/surveyor\\'s)",
                "key": "LEN_chG"
            }, {
                "description": "Chain (Ramden\\'s/engineer\\'s)",
                "key": "LEN_chR"
            }, {
                "description": "Cubic centimeter",
                "key": "VDRY_cm3"
            }, {
                "description": "Cubic foot",
                "key": "VDRY_ft3"
            }, {
                "description": "Cubic inch",
                "key": "VDRY_in3"
            }, {
                "description": "Cubic meter",
                "key": "VDRY_m3"
            }, {
                "description": "Cubic meter (liquid)",
                "key": "VLIQ_M3"
            }, {
                "description": "Cubic millimeter",
                "key": "VDRY_mm3"
            }, {
                "description": "Cubic yard",
                "key": "VDRY_yd3"
            }, {
                "description": "Cup",
                "key": "VLIQ_cup"
            }, {
                "description": "Decimeter",
                "key": "LEN_dm"
            }, {
                "description": "Degrees Celsius",
                "key": "TEMP_C"
            }, {
                "description": "Degrees Fahrenheit",
                "key": "TEMP_F"
            }, {
                "description": "Dekameter",
                "key": "LEN_dam"
            }, {
                "description": "Dram (US)",
                "key": "VLIQ_dr"
            }, {
                "description": "Dram (avdp)",
                "key": "WT_dr_avdp"
            }, {
                "description": "Each",
                "key": "OTH_ea"
            }, {
                "description": "Fathom",
                "key": "LEN_fm"
            }, {
                "description": "Foot",
                "key": "LEN_ft"
            }, {
                "description": "Furlong",
                "key": "LEN_fur"
            }, {
                "description": "Gallon (UK)",
                "key": "VLIQ_galUK"
            }, {
                "description": "Gallon (US)",
                "key": "VLIQ_galUS"
            }, {
                "description": "Gigabit of Data",
                "key": "DATA_Gb"
            }, {
                "description": "Gigabit-per-second of Data",
                "key": "DATASPD_Gbps"
            }, {
                "description": "Gigabyte of Data",
                "key": "DATA_GB"
            }, {
                "description": "Gill (1/4 UK pint)",
                "key": "VLIQ_gi"
            }, {
                "description": "Grain",
                "key": "WT_gr"
            }, {
                "description": "Gram",
                "key": "WT_g"
            }, {
                "description": "Hand (horse\\'s height)",
                "key": "LEN_hand"
            }, {
                "description": "Hectare",
                "key": "AREA_ha"
            }, {
                "description": "Hectoliter",
                "key": "VLIQ_HL"
            }, {
                "description": "Horsepower (mechanical)",
                "key": "EN_HP"
            }, {
                "description": "Inch",
                "key": "LEN_in"
            }, {
                "description": "Joule (absolute)",
                "key": "EN_J"
            }, {
                "description": "Kelvin",
                "key": "TEMP_K"
            }, {
                "description": "Kilobit of Data",
                "key": "DATA_Kb"
            }, {
                "description": "Kilobit-per-second of Data",
                "key": "DATASPD_Kbps"
            }, {
                "description": "Kilobyte of Data",
                "key": "DATA_KB"
            }, {
                "description": "Kilogram",
                "key": "WT_kg"
            }, {
                "description": "Kilometer",
                "key": "LEN_km"
            }, {
                "description": "Kilowatt",
                "key": "EN_Kw"
            }, {
                "description": "League",
                "key": "LEN_league"
            }, {
                "description": "Link (Gunter\\'s)",
                "key": "LEN_lnG"
            }, {
                "description": "Link (Ramden\\'s)",
                "key": "LEN_lnR"
            }, {
                "description": "Liter",
                "key": "VLIQ_L"
            }, {
                "description": "Megabit of Data",
                "key": "DATA_Mb"
            }, {
                "description": "Megabit-per-second of Data",
                "key": "DATASPD_Mbps"
            }, {
                "description": "Megabyte of Data",
                "key": "DATA_MB"
            }, {
                "description": "Meter",
                "key": "LEN_m"
            }, {
                "description": "Micrometer (Micron)",
                "key": "LEN_u"
            }, {
                "description": "Mil (Milli-inch)",
                "key": "LEN_mil"
            }, {
                "description": "Mile (nautical/sea)",
                "key": "LEN_nmi"
            }, {
                "description": "Mile (statute/land)",
                "key": "LEN_mi"
            }, {
                "description": "Milligram",
                "key": "WT_mg"
            }, {
                "description": "Milliliter",
                "key": "VLIQ_ml"
            }, {
                "description": "Millimeter",
                "key": "LEN_mm"
            }, {
                "description": "Mole - Substance (molecule)",
                "key": "OTH_mol"
            }, {
                "description": "Ounce (avdp)",
                "key": "WT_oz"
            }, {
                "description": "Ounce (troy)",
                "key": "WT_oz_tr"
            }, {
                "description": "Ounce, fluid (UK)",
                "key": "VLIQ_ozUK"
            }, {
                "description": "Ounce, fluid (US)",
                "key": "VLIQ_ozUS"
            }, {
                "description": "Package",
                "key": "OTH_pk"
            }, {
                "description": "Pennyweight",
                "key": "WT_dwt"
            }, {
                "description": "Per Person",
                "key": "OTH_pp"
            }, {
                "description": "Petabit of Data",
                "key": "DATA_Pb"
            }, {
                "description": "Petabyte of Data",
                "key": "DATA_PB"
            }, {
                "description": "Pica (type size)",
                "key": "LEN_pica"
            }, {
                "description": "Pint (UK)",
                "key": "VLIQ_ptUK"
            }, {
                "description": "Pint (US)",
                "key": "VLIQ_ptUS"
            }, {
                "description": "Point (type size)",
                "key": "LEN_point"
            }, {
                "description": "Pound (avdp)",
                "key": "WT_lb"
            }, {
                "description": "Quart",
                "key": "VLIQ_qt"
            }, {
                "description": "Rod",
                "key": "LEN_rd"
            }, {
                "description": "Square Centimeter",
                "key": "AREA_cm2"
            }, {
                "description": "Square Foot",
                "key": "AREA_ft2"
            }, {
                "description": "Square Inch",
                "key": "AREA_in2"
            }, {
                "description": "Square Kilometer",
                "key": "AREA_km2"
            }, {
                "description": "Square Meter",
                "key": "AREA_m2"
            }, {
                "description": "Square Mile",
                "key": "AREA_mi2"
            }, {
                "description": "Square Millimeter",
                "key": "AREA_mm2"
            }, {
                "description": "Square Rod",
                "key": "AREA_rd2"
            }, {
                "description": "Square Yard",
                "key": "AREA_yd2"
            }, {
                "description": "Stere (cubic meter)",
                "key": "VDRY_ST"
            }, {
                "description": "Stone",
                "key": "WT_st"
            }, {
                "description": "Tablespoon",
                "key": "VLIQ_Tbs"
            }, {
                "description": "Teaspoon",
                "key": "VLIQ_tsp"
            }, {
                "description": "Terabit of Data",
                "key": "DATA_Tb"
            }, {
                "description": "Terabit-per-second of Data",
                "key": "DATASPD_Tbps"
            }, {
                "description": "Terabyte of Data",
                "key": "DATA_TB"
            }, {
                "description": "Time in Centuries",
                "key": "TF_century"
            }, {
                "description": "Time in Days",
                "key": "TF_day"
            }, {
                "description": "Time in Decades",
                "key": "TF_decade"
            }, {
                "description": "Time in Hours",
                "key": "TF_hr"
            }, {
                "description": "Time in Millenia",
                "key": "TF_millenium"
            }, {
                "description": "Time in Milli-Seconds",
                "key": "TF_ms"
            }, {
                "description": "Time in Minutes",
                "key": "TF_min"
            }, {
                "description": "Time in Months",
                "key": "TF_mon"
            }, {
                "description": "Time in Scores",
                "key": "TF_score"
            }, {
                "description": "Time in Seconds",
                "key": "TF_s"
            }, {
                "description": "Time in Weeks",
                "key": "TF_wk"
            }, {
                "description": "Time in Years",
                "key": "TF_yr"
            }, {
                "description": "Ton (long or British)",
                "key": "WT_lt"
            }, {
                "description": "Ton (metric)",
                "key": "WT_mt"
            }, {
                "description": "Ton (short)",
                "key": "WT_sh_t"
            }, {
                "description": "Watt",
                "key": "EN_w"
            }, {
                "description": "Yard",
                "key": "LEN_yd"
            }],
            "disabled": "false",
            "id": "AddShipmentCostEstimate_quom",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "quom",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Per Unit Price",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "qprice",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_qprice",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "ajaxEnabled": false,
            "size": 0,
            "name": "PriceTitle2",
            "description": " ",
            "id": "AddShipmentCostEstimate_PriceTitle2",
            "type": "DISPLAY",
            "title": "",
            "imageLocation": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Min Pr",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "pmin",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_pmin",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Max Pr",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "pmax",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_pmax",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Price Break ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "AddShipmentCostEstimate",
            "options": [],
            "disabled": "false",
            "id": "AddShipmentCostEstimate_priceBreakId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "priceBreakId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Unit Of Measure",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "AddShipmentCostEstimate",
            "options": [{
                "description": "Afghani - AFN",
                "key": "AFN"
            }, {
                "description": "Albanian Lek - ALL",
                "key": "ALL"
            }, {
                "description": "Algerian Dinar - DZD",
                "key": "DZD"
            }, {
                "description": "American Dollar - USD",
                "key": "USD"
            }, {
                "description": "Angolan Kwanza - AOA",
                "key": "AOA"
            }, {
                "description": "Argentina Peso - ARS",
                "key": "ARS"
            }, {
                "description": "Armenian Dram - AMD",
                "key": "AMD"
            }, {
                "description": "Aruban Guilder - AWG",
                "key": "AWG"
            }, {
                "description": "Australian Dollar - AUD",
                "key": "AUD"
            }, {
                "description": "Azerbaijan Manat - AZN",
                "key": "AZN"
            }, {
                "description": "Bahaman Dollar - BSD",
                "key": "BSD"
            }, {
                "description": "Bahrain Dinar - BHD",
                "key": "BHD"
            }, {
                "description": "Bangladesh Taka - BDT",
                "key": "BDT"
            }, {
                "description": "Barbados Dollar - BBD",
                "key": "BBD"
            }, {
                "description": "Belize Dollar - BZD",
                "key": "BZD"
            }, {
                "description": "Belorussian Ruble - BYN",
                "key": "BYN"
            }, {
                "description": "Benin C.f.A. Franc - XOF",
                "key": "XOF"
            }, {
                "description": "Bermudan Dollar - BMD",
                "key": "BMD"
            }, {
                "description": "Bolivian Boliviano - BOB",
                "key": "BOB"
            }, {
                "description": "Botswana Pula - BWP",
                "key": "BWP"
            }, {
                "description": "Brazilian Real - BRL",
                "key": "BRL"
            }, {
                "description": "British Pound - GBP",
                "key": "GBP"
            }, {
                "description": "Brunei Dollar - BND",
                "key": "BND"
            }, {
                "description": "Bulgarian Lev - BGN",
                "key": "BGN"
            }, {
                "description": "Burundi Franc - BIF",
                "key": "BIF"
            }, {
                "description": "Cambodian Riel - KHR",
                "key": "KHR"
            }, {
                "description": "Canadian Dollar - CAD",
                "key": "CAD"
            }, {
                "description": "Cape Verde Escudo - CVE",
                "key": "CVE"
            }, {
                "description": "Cayman Dollar - KYD",
                "key": "KYD"
            }, {
                "description": "Chilean Peso - CLP",
                "key": "CLP"
            }, {
                "description": "China - CNY",
                "key": "CNY"
            }, {
                "description": "Colombian Peso - COP",
                "key": "COP"
            }, {
                "description": "Comoros Franc - KMF",
                "key": "KMF"
            }, {
                "description": "Convertible Marks - BAM",
                "key": "BAM"
            }, {
                "description": "Costa Rica Colon - CRC",
                "key": "CRC"
            }, {
                "description": "Croatian Kuna - HRK",
                "key": "HRK"
            }, {
                "description": "Cuban Peso - CUP",
                "key": "CUP"
            }, {
                "description": "Czech Krona - CZK",
                "key": "CZK"
            }, {
                "description": "Danish Krone - DKK",
                "key": "DKK"
            }, {
                "description": "Djibouti Franc - DJF",
                "key": "DJF"
            }, {
                "description": "Dominican Peso - DOP",
                "key": "DOP"
            }, {
                "description": "East Carribean Dollar - XCD",
                "key": "XCD"
            }, {
                "description": "Egyptian Pound - EGP",
                "key": "EGP"
            }, {
                "description": "El Salvador Colon - SVC",
                "key": "SVC"
            }, {
                "description": "Ethiopian Birr - ETB",
                "key": "ETB"
            }, {
                "description": "Euro - EUR",
                "key": "EUR"
            }, {
                "description": "Falkland Pound - FKP",
                "key": "FKP"
            }, {
                "description": "Fiji Dollar - FJD",
                "key": "FJD"
            }, {
                "description": "Gabon C.f.A Franc - XAF",
                "key": "XAF"
            }, {
                "description": "Gambian Dalasi - GMD",
                "key": "GMD"
            }, {
                "description": "Ghanian Cedi - GHS",
                "key": "GHS"
            }, {
                "description": "Gibraltar Pound - GIP",
                "key": "GIP"
            }, {
                "description": "Guatemalan Quedzal - GTQ",
                "key": "GTQ"
            }, {
                "description": "Guinea Franc - GNF",
                "key": "GNF"
            }, {
                "description": "Guyanese Dollar - GYD",
                "key": "GYD"
            }, {
                "description": "Haitian Gourde - HTG",
                "key": "HTG"
            }, {
                "description": "Honduran Lempira - HNL",
                "key": "HNL"
            }, {
                "description": "Hong Kong Dollar - HKD",
                "key": "HKD"
            }, {
                "description": "Hungarian forint - HUF",
                "key": "HUF"
            }, {
                "description": "Iceland Krona - ISK",
                "key": "ISK"
            }, {
                "description": "Indian Rupee - INR",
                "key": "INR"
            }, {
                "description": "Indonesian Rupiah - IDR",
                "key": "IDR"
            }, {
                "description": "Iranian Rial - IRR",
                "key": "IRR"
            }, {
                "description": "Iraqui Dinar - IQD",
                "key": "IQD"
            }, {
                "description": "Jamaican Dollar - JMD",
                "key": "JMD"
            }, {
                "description": "Japanese Yen - JPY",
                "key": "JPY"
            }, {
                "description": "Jordanian Dinar - JOD",
                "key": "JOD"
            }, {
                "description": "Kazakhstani Tenge - KZT",
                "key": "KZT"
            }, {
                "description": "Kenyan Shilling - KES",
                "key": "KES"
            }, {
                "description": "Kirghizstan Som - KGS",
                "key": "KGS"
            }, {
                "description": "Kuwaiti Dinar - KWD",
                "key": "KWD"
            }, {
                "description": "Laotian Kip - LAK",
                "key": "LAK"
            }, {
                "description": "Lari - GEL",
                "key": "GEL"
            }, {
                "description": "Lebanese Pound - LBP",
                "key": "LBP"
            }, {
                "description": "Leone - SLL",
                "key": "SLL"
            }, {
                "description": "Lesotho Loti - LSL",
                "key": "LSL"
            }, {
                "description": "Liberian Dollar - LRD",
                "key": "LRD"
            }, {
                "description": "Libyan Dinar - LYD",
                "key": "LYD"
            }, {
                "description": "Macao Pataca - MOP",
                "key": "MOP"
            }, {
                "description": "Malagascy Ariary - MGA",
                "key": "MGA"
            }, {
                "description": "Malawi Kwacha - MWK",
                "key": "MWK"
            }, {
                "description": "Malaysian Ringgit - MYR",
                "key": "MYR"
            }, {
                "description": "Maldive Rufiyaa - MVR",
                "key": "MVR"
            }, {
                "description": "Mauritanian Ouguiya - MRU",
                "key": "MRU"
            }, {
                "description": "Mauritius Rupee - MUR",
                "key": "MUR"
            }, {
                "description": "Mexican Peso - MXN",
                "key": "MXN"
            }, {
                "description": "Moldavian Lei - MDL",
                "key": "MDL"
            }, {
                "description": "Mongolian Tugrik - MNT",
                "key": "MNT"
            }, {
                "description": "Moroccan Dirham - MAD",
                "key": "MAD"
            }, {
                "description": "Mozambique Metical - MZN",
                "key": "MZN"
            }, {
                "description": "Nepalese Rupee - NPR",
                "key": "NPR"
            }, {
                "description": "New Israeli Shekel - ILS",
                "key": "ILS"
            }, {
                "description": "New Taiwan Dollar - TWD",
                "key": "TWD"
            }, {
                "description": "New Zaire - ZRN",
                "key": "ZRN"
            }, {
                "description": "New Zealand Dollar - NZD",
                "key": "NZD"
            }, {
                "description": "Nicaraguan Cordoba - NIO",
                "key": "NIO"
            }, {
                "description": "Nigerian Naira - NGN",
                "key": "NGN"
            }, {
                "description": "North Korean Won - KPW",
                "key": "KPW"
            }, {
                "description": "Norwegian Krone - NOK",
                "key": "NOK"
            }, {
                "description": "Omani Rial - OMR",
                "key": "OMR"
            }, {
                "description": "Pakistan Rupee - PKR",
                "key": "PKR"
            }, {
                "description": "Panamanian Balboa - PAB",
                "key": "PAB"
            }, {
                "description": "Papua New Guinea Kina - PGK",
                "key": "PGK"
            }, {
                "description": "Paraguayan Guarani - PYG",
                "key": "PYG"
            }, {
                "description": "Peruvian Sol - PEN",
                "key": "PEN"
            }, {
                "description": "Philippino Peso - PHP",
                "key": "PHP"
            }, {
                "description": "Polish Zloty - PLN",
                "key": "PLN"
            }, {
                "description": "Qatar Riyal - QAR",
                "key": "QAR"
            }, {
                "description": "Romanian Leu - RON",
                "key": "RON"
            }, {
                "description": "Russian Rouble - RUB",
                "key": "RUB"
            }, {
                "description": "Rwanda Franc - RWF",
                "key": "RWF"
            }, {
                "description": "Samoan Tala - WST",
                "key": "WST"
            }, {
                "description": "Sao Tome and Principe Dobra - STN",
                "key": "STN"
            }, {
                "description": "Saudi Riyal - SAR",
                "key": "SAR"
            }, {
                "description": "Seychelles Rupee - SCR",
                "key": "SCR"
            }, {
                "description": "Singapore Dollar - SGD",
                "key": "SGD"
            }, {
                "description": "Solomon Islands Dollar - SBD",
                "key": "SBD"
            }, {
                "description": "Somalian Shilling - SOS",
                "key": "SOS"
            }, {
                "description": "South African Rand - ZAR",
                "key": "ZAR"
            }, {
                "description": "South Korean Won - KRW",
                "key": "KRW"
            }, {
                "description": "South Sudanese Pound - SSP",
                "key": "SSP"
            }, {
                "description": "Sri Lankan Rupee - LKR",
                "key": "LKR"
            }, {
                "description": "St.Helena Pound - SHP",
                "key": "SHP"
            }, {
                "description": "Sudanese Pound - SDG",
                "key": "SDG"
            }, {
                "description": "Surinam Dollar - SRD",
                "key": "SRD"
            }, {
                "description": "Swaziland Lilangeni - SZL",
                "key": "SZL"
            }, {
                "description": "Swedish Krona - SEK",
                "key": "SEK"
            }, {
                "description": "Swiss Franc - CHF",
                "key": "CHF"
            }, {
                "description": "Syrian Pound - SYP",
                "key": "SYP"
            }, {
                "description": "Tadzhikistani Somoni - TJS",
                "key": "TJS"
            }, {
                "description": "Tanzanian Shilling - TZS",
                "key": "TZS"
            }, {
                "description": "Thailand Baht - THB",
                "key": "THB"
            }, {
                "description": "Tongan Pa\\'anga - TOP",
                "key": "TOP"
            }, {
                "description": "Trinidad and Tobago Dollar - TTD",
                "key": "TTD"
            }, {
                "description": "Tunisian Dinar - TND",
                "key": "TND"
            }, {
                "description": "Turkish Lira - TRY",
                "key": "TRY"
            }, {
                "description": "Turkmenistani Manat - TMT",
                "key": "TMT"
            }, {
                "description": "Ugandan Shilling - UGX",
                "key": "UGX"
            }, {
                "description": "Ukrainian Hryvnia - UAH",
                "key": "UAH"
            }, {
                "description": "United Arab Emirates Dirham - AED",
                "key": "AED"
            }, {
                "description": "Uruguay - UYU",
                "key": "UYU"
            }, {
                "description": "Uruguay Peso en Unidades Indexadas (UI) - UYI",
                "key": "UYI"
            }, {
                "description": "Vanuatu Vatu - VUV",
                "key": "VUV"
            }, {
                "description": "Venezuelan Bolívar Soberano - VES",
                "key": "VES"
            }, {
                "description": "Vietnamese Dong - VND",
                "key": "VND"
            }, {
                "description": "West Indian Guilder - ANG",
                "key": "ANG"
            }, {
                "description": "Yemeni Ryal - YER",
                "key": "YER"
            }, {
                "description": "Zambian Kwacha - ZMW",
                "key": "ZMW"
            }, {
                "description": "Zimbabwean Dollar - ZWL",
                "key": "ZWL"
            }],
            "disabled": "false",
            "id": "AddShipmentCostEstimate_puom",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "puom",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Per Unit Price",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "pprice",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddShipmentCostEstimate_pprice",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "AddShipmentCostEstimate",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "AddShipmentCostEstimate_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Submit",
            "event": "",
            "imgSrc": ""
        }],
        "target": "storeCreateShipRate"
    },
    {
        "fieldSets": [{
            "fieldSetName": "Default",
            "fields": ["paymentMethodTypeId", "paymentServiceTypeEnumId", "paymentService", "paymentCustomMethodId", "paymentGatewayConfigId", "paymentPropertiesPath", "applyToAllProducts", "editLink", "deleteLink"]
        }],
        "columns": [{
            "name": "paymentMethodTypeId",
            "title": "Payment Method Type"
        }, {
            "name": "paymentServiceTypeEnumId",
            "title": "Service Type"
        }, {
            "name": "paymentService",
            "title": "Service Name"
        }, {
            "name": "paymentCustomMethodId",
            "title": "Custom Method"
        }, {
            "name": "paymentGatewayConfigId",
            "title": "Payment Gateway Config ID"
        }, {
            "name": "paymentPropertiesPath",
            "title": "Payment Props"
        }, {
            "name": "applyToAllProducts",
            "title": "Apply To All"
        }, {
            "name": "editLink",
            "title": " "
        }, {
            "name": "deleteLink",
            "title": " "
        }],
        "formName": "ListProductStorePaymentSettings",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "ListProductStorePaymentSettings_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": "9000Id=WSCO10731"
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "paymentMethodTypeId",
            "description": "",
            "style": "",
            "id": "ListProductStorePaymentSettings_paymentMethodTypeId",
            "title": "Payment Method Type",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "paymentServiceTypeEnumId",
            "description": "",
            "style": "",
            "id": "ListProductStorePaymentSettings_paymentServiceTypeEnumId",
            "title": "Service Type",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "paymentService",
            "description": "",
            "style": "",
            "id": "ListProductStorePaymentSettings_paymentService",
            "title": "Service Name",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "paymentCustomMethodId",
            "description": "",
            "style": "",
            "id": "ListProductStorePaymentSettings_paymentCustomMethodId",
            "title": "Custom Method",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "paymentGatewayConfigId",
            "description": "",
            "style": "",
            "id": "ListProductStorePaymentSettings_paymentGatewayConfigId",
            "title": "Payment Gateway Config ID",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "paymentPropertiesPath",
            "description": "",
            "style": "",
            "id": "ListProductStorePaymentSettings_paymentPropertiesPath",
            "title": "Payment Props",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "applyToAllProducts",
            "description": "",
            "style": "",
            "id": "ListProductStorePaymentSettings_applyToAllProducts",
            "title": "Apply To All",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "ajaxEnabled": false,
            "size": 0,
            "name": "editLink",
            "description": "",
            "id": "ListProductStorePaymentSettings_editLink",
            "type": "DISPLAY",
            "title": " ",
            "imageLocation": ""
        }, {
            "ajaxEnabled": false,
            "size": 0,
            "name": "deleteLink",
            "description": "",
            "id": "ListProductStorePaymentSettings_deleteLink",
            "type": "DISPLAY",
            "title": " ",
            "imageLocation": ""
        }],
        "target": ""
    },
    {
        "formName": "EditProductStorePaymentSetting",
        "altTarget": [{
            "useWhen": "productStorePaymentSetting==null",
            "targetExdr": {
                "chars": "storeCreatePaySetting",
                "hint": 20,
                "empty": false,
                "original": "storeCreatePaySetting"
            }
        }],
        "targets": {
            "createTarget": "storeCreatePaySetting",
            "updateTarget": "storeUpdatePaySetting"
        },
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "EditProductStorePaymentSetting_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Payment Method Type",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStorePaymentSetting",
            "options": [{
                "description": "Billing Account",
                "key": "EXT_BILLACT"
            }, {
                "description": "Cash",
                "key": "CASH"
            }, {
                "description": "Cash On Delivery",
                "key": "EXT_COD"
            }, {
                "description": "Certified Check",
                "key": "CERTIFIED_CHECK"
            }, {
                "description": "Company Account",
                "key": "COMPANY_ACCOUNT"
            }, {
                "description": "Company Check",
                "key": "COMPANY_CHECK"
            }, {
                "description": "Credit Card",
                "key": "CREDIT_CARD"
            }, {
                "description": "Electronic Funds Transfer",
                "key": "EFT_ACCOUNT"
            }, {
                "description": "Financial Account",
                "key": "FIN_ACCOUNT"
            }, {
                "description": "Gift Card",
                "key": "GIFT_CARD"
            }, {
                "description": "Gift Certificate",
                "key": "GIFT_CERTIFICATE"
            }, {
                "description": "Money Order",
                "key": "MONEY_ORDER"
            }, {
                "description": "Offline Payment",
                "key": "EXT_OFFLINE"
            }, {
                "description": "PayPal",
                "key": "EXT_PAYPAL"
            }, {
                "description": "Personal Check",
                "key": "PERSONAL_CHECK"
            }, {
                "description": "RBS WorldPay",
                "key": "EXT_WORLDPAY"
            }, {
                "description": "eBay",
                "key": "EXT_EBAY"
            }],
            "disabled": "false",
            "id": "EditProductStorePaymentSetting_paymentMethodTypeId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "paymentMethodTypeId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Service Type",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStorePaymentSetting",
            "options": [{
                "description": "External Payment (No Service)",
                "key": "PRDS_PAY_EXTERNAL"
            }, {
                "description": "Payment Auth Verification Service",
                "key": "PRDS_PAY_AUTH_VERIFY"
            }, {
                "description": "Payment Authorization Service",
                "key": "PRDS_PAY_AUTH"
            }, {
                "description": "Payment Capture Service",
                "key": "PRDS_PAY_CAPTURE"
            }, {
                "description": "Payment Credit Service",
                "key": "PRDS_PAY_CREDIT"
            }, {
                "description": "Payment Re-Authorization Service",
                "key": "PRDS_PAY_REAUTH"
            }, {
                "description": "Payment Refund Service",
                "key": "PRDS_PAY_REFUND"
            }, {
                "description": "Payment Release Authorization Service",
                "key": "PRDS_PAY_RELEASE"
            }],
            "disabled": "false",
            "id": "EditProductStorePaymentSetting_paymentServiceTypeEnumId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "paymentServiceTypeEnumId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Service Name",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "paymentService",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStorePaymentSetting_paymentService",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Custom Method",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStorePaymentSetting",
            "options": [{
                "description": "CC Always authorize (alwaysApproveCCProcessor)",
                "key": "CC_AUTH_ALWAYSAPPROV"
            }, {
                "description": "CC Always authorize and capture (alwaysApproveWithCaptureCCProcessor)",
                "key": "CC_AUTH_CAPTURE_ALWA"
            }, {
                "description": "CC Always decline (alwaysDeclineCCProcessor)",
                "key": "CC_AUTH_ALWAYSDECLIN"
            }, {
                "description": "CC Always decline capture (testCCProcessorCaptureAlwaysDecline)",
                "key": "CC_CAPTURE_ALWAYSDEC"
            }, {
                "description": "CC Always decline for bad card number (alwaysBadCardNumberCCProcessor)",
                "key": "CC_AUTH_ALWAYSBADNUM"
            }, {
                "description": "CC Always decline for fail/bad expire date (alwaysBadExpireCCProcessor)",
                "key": "CC_AUTH_ALWAYSBAD"
            }, {
                "description": "CC Always decline for fail/bad expire date when year is even (badExpireEvenCCProcessor)",
                "key": "CC_AUTH_ALWAYSEVEN"
            }, {
                "description": "CC Always decline for not sufficient funds (alwaysNsfCCProcessor)",
                "key": "CC_AUTH_ALWAYSNSF"
            }, {
                "description": "CC Always fail (alwaysBadCardNumberCCProcessor)",
                "key": "CC_AUTH_ALWAYSFAIL"
            }, {
                "description": "CC Authorize First Data (firstDataCCAuth)",
                "key": "CC_AUTH_FD"
            }, {
                "description": "CC Authorize dot net authorize (aimCCAuth)",
                "key": "CC_AUTH_AIM"
            }, {
                "description": "CC Authorize dot net authorize and capture (aimCCAuthCapture)",
                "key": "CC_AUTH_CAPTURE_AIM"
            }, {
                "description": "CC Authorize dot net capture (aimCCCapture)",
                "key": "CC_CAPTURE_AIM"
            }, {
                "description": "CC Authorize dot net credit (aimCCCredit)",
                "key": "CC_CREDIT_AIM"
            }, {
                "description": "CC Authorize dot net refund (aimCCRefund)",
                "key": "CC_REFUND_AIM"
            }, {
                "description": "CC Authorize dot net release (aimCCRelease)",
                "key": "CC_RELEASE_AIM"
            }, {
                "description": "CC Capture First Data (firstDataCCCapture)",
                "key": "CC_CAPTURE_FD"
            }, {
                "description": "CC Clear Commerce authorize (clearCommerceCCAuth)",
                "key": "CC_AUTH_CLEARCOMMERC"
            }, {
                "description": "CC Clear Commerce authorize reporting facility (clearCommerceCCReport)",
                "key": "CC_AUTH_CLEARCOM_REP"
            }, {
                "description": "CC Clear Commerce capture (clearCommerceCCCapture)",
                "key": "CC_CAPTURE_CLEARCOMM"
            }, {
                "description": "CC Clear Commerce credit (clearCommerceCCCredit)",
                "key": "CC_CREDIT_CLEARCOMME"
            }, {
                "description": "CC Clear Commerce refund (clearCommerceCCRefund)",
                "key": "CC_REFUND_CLEARCOMME"
            }, {
                "description": "CC Clear Commerce release (clearCommerceCCRelease)",
                "key": "CC_RELEASE_CLEARCOMM"
            }, {
                "description": "CC CyberSource authorize (cyberSourceCCAuth)",
                "key": "CC_AUTH_CYBERSOURCE"
            }, {
                "description": "CC CyberSource capture (cyberSourceCCCapture)",
                "key": "CC_CAPTURE_CYBERSOUR"
            }, {
                "description": "CC CyberSource credit (cyberSourceCCCredit)",
                "key": "CC_CREDIT_CYBERSOURC"
            }, {
                "description": "CC CyberSource refund (cyberSourceCCRefund)",
                "key": "CC_REFUND_CYBERSOURC"
            }, {
                "description": "CC CyberSource release (cyberSourceCCRelease)",
                "key": "CC_RELEASE_CYBERSOUR"
            }, {
                "description": "CC Orbital authorize (orbitalCCAuth)",
                "key": "CC_AUTH_ORBITAL"
            }, {
                "description": "CC Orbital authorize and capture (orbitalCCAuthCapture)",
                "key": "CC_AUTH_CAPTR_ORBTL"
            }, {
                "description": "CC Orbital capture (orbitalCCCapture)",
                "key": "CC_CAPTURE_ORBITAL"
            }, {
                "description": "CC Orbital refund (orbitalCCRefund)",
                "key": "CC_REFUND_ORBITAL"
            }, {
                "description": "CC Orbital release (orbitalCCRelease)",
                "key": "CC_RELEASE_ORBITAL"
            }, {
                "description": "CC PCCharge authorize (pcChargeCCAuth)",
                "key": "CC_AUTH_PCCHARGE"
            }, {
                "description": "CC PCCharge capture (pcChargeCCCapture)",
                "key": "CC_CAPTURE_PCCHARGE"
            }, {
                "description": "CC PCCharge refund (pcChargeCCRefund)",
                "key": "CC_REFUND_PCCHARGE"
            }, {
                "description": "CC PCCharge release (pcChargeCCRelease)",
                "key": "CC_RELEASE_PCCHARGE"
            }, {
                "description": "CC Payflow Pro authorize (payflowCCProcessor)",
                "key": "CC_AUTH_PAYFLOW"
            }, {
                "description": "CC Payflow Pro capture (payflowCCCapture)",
                "key": "CC_CAPTURE_PAYFLOW"
            }, {
                "description": "CC Payflow Pro refund (payflowCCRefund)",
                "key": "CC_REFUND_PAYFLOW"
            }, {
                "description": "CC Payflow Pro release (payflowCCVoid)",
                "key": "CC_RELEASE_PAYFLOW"
            }, {
                "description": "CC Refund First Data (firstDataCCRefund)",
                "key": "CC_REFUND_FD"
            }, {
                "description": "CC Release First Data (firstDataCCRelease)",
                "key": "CC_RELEASE_FD"
            }, {
                "description": "CC RiTA authorize (ritaCCAuth)",
                "key": "CC_AUTH_RITA"
            }, {
                "description": "CC RiTA capture (ritaCCCapture)",
                "key": "CC_CAPTURE_RITA"
            }, {
                "description": "CC RiTA credit (ritaCCCreditRefund)",
                "key": "CC_CREDIT_RITA"
            }, {
                "description": "CC RiTA refund (ritaCCRefund)",
                "key": "CC_REFUND_RITA"
            }, {
                "description": "CC RiTA release (ritaCCRelease)",
                "key": "CC_RELEASE_RITA"
            }, {
                "description": "CC RiTA remote authorize (ritaCCAuthRemote)",
                "key": "CC_AUTH_RITA_REMOTE"
            }, {
                "description": "CC RiTA remote capture (ritaCCCaptureRemote)",
                "key": "CC_CAPTURE_RITA_REMO"
            }, {
                "description": "CC RiTA remote refund (ritaCCRefundRemote)",
                "key": "CC_REFUND_RITA_REMOT"
            }, {
                "description": "CC RiTA remote release (ritaCCReleaseRemote)",
                "key": "CC_RELEASE_RITA_REMO"
            }, {
                "description": "CC Test authorize (testCCProcessor)",
                "key": "CC_AUTH_TEST"
            }, {
                "description": "CC Test authorize and capture (testCCProcessorWithCapture)",
                "key": "CC_AUTH_CAPTURE_TST"
            }, {
                "description": "CC Test capture (testCCCapture)",
                "key": "CC_CAPTURE_TEST"
            }, {
                "description": "CC Test random authorize (testRandomAuthorize)",
                "key": "CC_AUTH_RANDOM_TEST"
            }, {
                "description": "CC Test reauth capture (testCCCaptureWithReAuth)",
                "key": "CC_CAPTURE_REAUTH"
            }, {
                "description": "CC Test refund (testCCRefund)",
                "key": "CC_REFUND_TEST"
            }, {
                "description": "CC Test refund failure (testCCRefundFailure)",
                "key": "CC_REFUND_TEST_FAIL"
            }, {
                "description": "CC Test release (testCCRelease)",
                "key": "CC_RELEASE_TEST"
            }, {
                "description": "EFT always authorize (alwaysApproveEFTProcessor)",
                "key": "EFT_AUTH_ALWAYSAPPRO"
            }, {
                "description": "EFT always decline (alwaysDeclineEFTProcessor)",
                "key": "EFT_AUTH_ALWAYSDECLI"
            }, {
                "description": "EFT test authorize (testEFTProcessor)",
                "key": "EFT_AUTH_TEST"
            }, {
                "description": "EFT test release (testEFTRelease)",
                "key": "EFT_RELEASE_TEST"
            }, {
                "description": "FIN account authorize (ofbFaAuthorize)",
                "key": "FIN_AUTH_OFBIZ"
            }, {
                "description": "FIN account capture (ofbFaCapture)",
                "key": "FIN_CAPTURE_OFBIZ"
            }, {
                "description": "FIN account refund (ofbFaRefund)",
                "key": "FIN_REFUND_OFBIZ"
            }, {
                "description": "FIN account release (ofbFaRelease)",
                "key": "FIN_RELEASE_OFBIZ"
            }, {
                "description": "GIFT card ValueLink authorize (valueLinkProcessor)",
                "key": "GIFT_AUTH_VALUELINK"
            }, {
                "description": "GIFT card ValueLink refund (valueLinkRefund)",
                "key": "GIFT_REFUND_VALUELI"
            }, {
                "description": "GIFT card ValueLink release (valueLinkRelease)",
                "key": "GIFT_RELEASE_VALUEL"
            }, {
                "description": "GIFT card always authorize (alwaysApproveGCProcessor)",
                "key": "GIFT_AUTH_ALWAYSAPPR"
            }, {
                "description": "GIFT card always decline (alwaysDeclineGCProcessor)",
                "key": "GIFT_AUTH_ALWAYSDECL"
            }, {
                "description": "GIFT card authorize (ofbGcAuthorize)",
                "key": "GIFT_AUTH_OFBIZ"
            }, {
                "description": "GIFT card capture (ofbGcProcessor)",
                "key": "GIFT_CAPTURE_OFBIZ"
            }, {
                "description": "GIFT card refund (ofbGcRefund)",
                "key": "GIFT_REFUND_OFBIZ"
            }, {
                "description": "GIFT card release (ofbGcRelease)",
                "key": "GIFT_RELEASE_OFBIZ"
            }, {
                "description": "GIFT card test release (testGCRelease)",
                "key": "GIFT_RELEASE_TEST"
            }, {
                "description": "SecurePay Credit Card (ofbScCCCredit)",
                "key": "SECURE_CREDIT_OFBIZ"
            }, {
                "description": "SecurePay payment authorize (ofbScAuthorize)",
                "key": "SECURE_AUTH_OFBIZ"
            }, {
                "description": "SecurePay payment capture (ofbScCapture)",
                "key": "SECURE_CAPTURE_OFBIZ"
            }, {
                "description": "SecurePay payment refund (ofbScRefund)",
                "key": "SECURE_REFUND_OFBIZ"
            }, {
                "description": "SecurePay payment release (ofbScRelease)",
                "key": "SECURE_RELEASE_OFBIZ"
            }, {
                "description": "eWay CC Charge (ewayCharge)",
                "key": "CC_CHARGE_EWAY"
            }, {
                "description": "eWay CC Refund (ewayRefund)",
                "key": "CC_REFUND_EWAY"
            }, {
                "description": "eWay CC Release (ewayRelease)",
                "key": "CC_RELEASE_EWAY"
            }],
            "disabled": "false",
            "id": "EditProductStorePaymentSetting_paymentCustomMethodId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "paymentCustomMethodId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "AccountingPaymentGatewayConfigId",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "Y",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStorePaymentSetting",
            "options": [{
                "description": "Authorize Dot Net Config",
                "key": "AUTHORIZE_NET_CONFIG"
            }, {
                "description": "Clear Commerce Config",
                "key": "CLEARCOMMERCE_CONFIG"
            }, {
                "description": "CyberSource Config",
                "key": "CYBERSOURCE_CONFIG"
            }, {
                "description": "Orbital Config",
                "key": "ORBITAL_CONFIG"
            }, {
                "description": "PayPal Config",
                "key": "PAYPAL_CONFIG"
            }, {
                "description": "Payflow Pro Config",
                "key": "PAYFLOWPRO_CONFIG"
            }, {
                "description": "RBS WorldPay Config",
                "key": "WORLDPAY_CONFIG"
            }, {
                "description": "SagePay Config",
                "key": "SAGEPAY_CONFIG"
            }, {
                "description": "SecurePay Config",
                "key": "SECUREPAY_CONFIG"
            }, {
                "description": "eWay Config",
                "key": "EWAY_CONFIG"
            }],
            "disabled": "false",
            "id": "EditProductStorePaymentSetting_paymentGatewayConfigId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "paymentGatewayConfigId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Payment Props",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "paymentPropertiesPath",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStorePaymentSetting_paymentPropertiesPath",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Apply To All Products",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStorePaymentSetting",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStorePaymentSetting_applyToAllProducts",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "applyToAllProducts",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "EditProductStorePaymentSetting",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "EditProductStorePaymentSetting_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Submit",
            "event": "",
            "imgSrc": ""
        }],
        "target": "storeUpdatePaySetting"
    },
    {
        "columns": [{
            "name": "productStoreId",
            "title": "Product Store ID"
        }, {
            "name": "finAccountTypeId",
            "title": "Fin Account Type ID"
        }, {
            "name": "requirePinCode",
            "title": "Require Pin Code"
        }, {
            "name": "validateGCFinAcct",
            "title": "Validate the Gift Card's financial Account"
        }, {
            "name": "accountCodeLength",
            "title": "Account Code Length"
        }, {
            "name": "pinCodeLength",
            "title": "Pin Code Length"
        }, {
            "name": "accountValidDays",
            "title": "Account Valid Days"
        }, {
            "name": "authValidDays",
            "title": "Auth Valid Days"
        }, {
            "name": "purchaseSurveyId",
            "title": "Purchase Survey ID"
        }, {
            "name": "purchSurveySendTo",
            "title": "Purch Survey Send To"
        }, {
            "name": "purchSurveyCopyMe",
            "title": "Purch Survey Copy Me"
        }, {
            "name": "allowAuthToNegative",
            "title": "Allow Auth To Negative"
        }, {
            "name": "minBalance",
            "title": "Min Balance"
        }, {
            "name": "replenishThreshold",
            "title": "Replenish Threshold"
        }, {
            "name": "replenishMethodEnumId",
            "title": "Replenish Method Enum ID"
        }, {
            "name": "remove",
            "title": " "
        }, {
            "name": "edit",
            "title": " "
        }],
        "formName": "ListProductStoreFinAccountSettings",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "finAccountTypeId",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_finAccountTypeId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "requirePinCode",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_requirePinCode",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "validateGCFinAcct",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_validateGCFinAcct",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "accountCodeLength",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_accountCodeLength",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "pinCodeLength",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_pinCodeLength",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "accountValidDays",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_accountValidDays",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "authValidDays",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_authValidDays",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "purchaseSurveyId",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_purchaseSurveyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "purchSurveySendTo",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_purchSurveySendTo",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "purchSurveyCopyMe",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_purchSurveyCopyMe",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "allowAuthToNegative",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_allowAuthToNegative",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "minBalance",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_minBalance",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "replenishThreshold",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_replenishThreshold",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "replenishMethodEnumId",
            "description": "",
            "style": "",
            "id": "ListProductStoreFinAccountSettings_replenishMethodEnumId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "image": "",
            "width": "",
            "name": "remove",
            "alternate": "",
            "description": "Remove",
            "parameterList": [{
                "name": "productStoreId"
            }, {
                "name": "finAccountTypeId"
            }],
            "id": "ListProductStoreFinAccountSettings_remove",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "target": "RemoveProductStoreFinAccountSettings"
        }, {
            "image": "",
            "width": "",
            "name": "edit",
            "alternate": "",
            "description": "Edit",
            "parameterList": [{
                "name": "productStoreId"
            }, {
                "name": "finAccountTypeId"
            }],
            "id": "ListProductStoreFinAccountSettings_edit",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "target": "EditProductStoreFinAccountSettings"
        }],
        "target": "UpdateProductStoreFinAccountSettings"
    },
    {
        "formName": "EditProductStoreFinAccountSettings",
        "altTarget": [{
            "useWhen": "finAccountSetting==null",
            "targetExdr": {
                "chars": "CreateProductStoreFinAccountSettings",
                "hint": 20,
                "empty": false,
                "original": "CreateProductStoreFinAccountSettings"
            }
        }],
        "targets": {
            "createTarget": "CreateProductStoreFinAccountSettings",
            "updateTarget": "UpdateProductStoreFinAccountSettings"
        },
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "EditProductStoreFinAccountSettings_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "spacer",
            "action": "",
            "id": "EditProductStoreFinAccountSettings_spacer",
            "type": "DISPLAY",
            "event": "",
            "value": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Fin Account Type ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreFinAccountSettings",
            "options": [{
                "description": "Gift Certificate",
                "key": "GIFTCERT_ACCOUNT"
            }, {
                "description": "Deposit Account",
                "key": "DEPOSIT_ACCOUNT"
            }, {
                "description": "Bank Account",
                "key": "BANK_ACCOUNT"
            }, {
                "description": "Store Credit Account",
                "key": "STORE_CREDIT_ACCT"
            }, {
                "description": "Investment Account",
                "key": "INVESTMENT_ACCOUNT"
            }, {
                "description": "Replenish Account",
                "key": "REPLENISH_ACCOUNT"
            }, {
                "description": "Service Credit Account",
                "key": "SVCCRED_ACCOUNT"
            }, {
                "description": "Loan Account",
                "key": "LOAN_ACCOUNT"
            }, {
                "description": "Credit Card Account",
                "key": "CREDIT_CARD_ACCOUNT"
            }, {
                "description": "Equity Line Account",
                "key": "EQUITY_LINE_ACCOUNT"
            }],
            "disabled": "false",
            "id": "EditProductStoreFinAccountSettings_finAccountTypeId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "finAccountTypeId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Require Pin Code",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreFinAccountSettings",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStoreFinAccountSettings_requirePinCode",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "first-in-list",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "requirePinCode",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Validate the Gift Card's financial Account",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreFinAccountSettings",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStoreFinAccountSettings_validateGCFinAcct",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "first-in-list",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "validateGCFinAcct",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Account Code Length",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "accountCodeLength",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFinAccountSettings_accountCodeLength",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Pin Code Length",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "pinCodeLength",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFinAccountSettings_pinCodeLength",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Account Valid Days",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "accountValidDays",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFinAccountSettings_accountValidDays",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Auth Valid Days",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "authValidDays",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFinAccountSettings_authValidDays",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "20",
            "ajaxUrl": "",
            "maxlength": "20",
            "tabindex": "",
            "className": "",
            "title": "Purchase Survey ID",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "purchaseSurveyId",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFinAccountSettings_purchaseSurveyId",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "20",
            "ajaxUrl": "",
            "maxlength": "20",
            "tabindex": "",
            "className": "",
            "title": "Purch Survey Send To",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "purchSurveySendTo",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFinAccountSettings_purchSurveySendTo",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "20",
            "ajaxUrl": "",
            "maxlength": "20",
            "tabindex": "",
            "className": "",
            "title": "Purch Survey Copy Me",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "purchSurveyCopyMe",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFinAccountSettings_purchSurveyCopyMe",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Allow Auth To Negative",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreFinAccountSettings",
            "options": [{
                "description": "Y",
                "key": "Y"
            }, {
                "description": "N",
                "key": "N"
            }],
            "disabled": "false",
            "id": "EditProductStoreFinAccountSettings_allowAuthToNegative",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "first-in-list",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "allowAuthToNegative",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Min Balance",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "minBalance",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFinAccountSettings_minBalance",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "6",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Replenish Threshold",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "replenishThreshold",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFinAccountSettings_replenishThreshold",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Replenish Method Enum ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "FARP_TOP_OFF",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreFinAccountSettings",
            "options": [{
                "description": "Top-off",
                "key": "FARP_TOP_OFF"
            }, {
                "description": "Replenish-level",
                "key": "FARP_REPLENISH_LEVEL"
            }],
            "disabled": "false",
            "id": "EditProductStoreFinAccountSettings_replenishMethodEnumId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "replenishMethodEnumId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "ajaxEnabled": false,
            "size": 0,
            "name": "spacer",
            "description": "",
            "id": "EditProductStoreFinAccountSettings_spacer",
            "type": "DISPLAY",
            "title": "",
            "imageLocation": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "EditProductStoreFinAccountSettings",
            "tabindex": "",
            "name": "submit",
            "className": "smallSubmit",
            "id": "EditProductStoreFinAccountSettings_submit",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Submit",
            "event": "",
            "imgSrc": ""
        }],
        "target": "UpdateProductStoreFinAccountSettings"
    },
    {
        "columns": [{
            "name": "submitButton",
            "title": " "
        }, {
            "name": "facilityId",
            "title": "Facility ID"
        }, {
            "name": "sequenceNum",
            "title": "Sequence Num"
        }, {
            "name": "fromDate",
            "title": "From Date"
        }, {
            "name": "thruDate",
            "title": "Through Date"
        }, {
            "name": "deleteLink",
            "title": " "
        }],
        "formName": "ListProductStoreFacility",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "ListProductStoreFacility_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "image": "/images/mini-edit.png",
            "width": "",
            "name": "submitButton",
            "alternate": "",
            "description": "",
            "parameterList": [],
            "id": "ListProductStoreFacility_submitButton",
            "imageTitle": "Edit",
            "parameterMap": {},
            "height": "",
            "target": "javascript:ajaxUpdateArea('ProductStoreFacilityEditArea', 'editProductStoreFacility', 'productStoreId=&facilityId=&fromDate=');"
        }, {
            "hyperlink": {
                "linkStyle": "link",
                "description": "[]",
                "targetType": "inter-app",
                "confirmation": "",
                "parameterMap": {
                    "VIEW_SIZE_0": "20",
                    "VIEW_INDEX_0": "0"
                },
                "uniqueItemName": "Modal_3efb2514_1b78_4fd3_9ef9_d9443a3146b2",
                "target": "/facility/control/EditFacility",
                "targetWindow": "",
                "remoteFormData": {
                    "formData": {
                        "formName": "EditFacility",
                        "formLocation": "component://kwikstore/widget/StoreForms.xml",
                        "link": "/admin/catalogs/catalog/${prodCatalogId}"
                    }
                }
            },
            "event": "edit",
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "facilityId",
            "description": "",
            "style": "",
            "id": "ListProductStoreFacility_facilityId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "sequenceNum",
            "description": "",
            "style": "",
            "id": "ListProductStoreFacility_sequenceNum",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "fromDate",
            "description": "",
            "style": "",
            "id": "ListProductStoreFacility_fromDate",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "thruDate",
            "description": "",
            "style": "",
            "id": "ListProductStoreFacility_thruDate",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "image": "/images/mini-trash.png",
            "width": "",
            "name": "deleteLink",
            "alternate": "",
            "description": "",
            "parameterList": [],
            "id": "ListProductStoreFacility_deleteLink",
            "imageTitle": "Remove",
            "parameterMap": {},
            "height": "",
            "target": "javascript:ajaxUpdateArea('PP_ProductStoreFacilityPrdStoreFacilityMgmt00001', 'deleteProductStoreFacility', 'productStoreId=&facilityId=&fromDate=');"
        }],
        "target": ""
    },
    {
        "formName": "EditProductStoreFacility",
        "altTarget": [{
            "useWhen": "productStoreFacility != null",
            "targetExdr": {
                "chars": "updateProductStoreFacility",
                "hint": 20,
                "empty": false,
                "original": "updateProductStoreFacility"
            }
        }],
        "targets": {
            "createTarget": "addProductStoreFacility",
            "updateTarget": "updateProductStoreFacility"
        },
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "EditProductStoreFacility_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Facility ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreFacility",
            "options": [{
                "description": "Web Store Warehouse [WebStoreWarehouse]",
                "key": "WebStoreWarehouse"
            }, {
                "description": "Regional Warehouse1 [RegionalWarehouse1]",
                "key": "RegionalWarehouse1"
            }, {
                "description": "Regional Warehouse2 [RegionalWarehouse2]",
                "key": "RegionalWarehouse2"
            }, {
                "description": "Store Warehouse1 [StoreWarehouse1]",
                "key": "StoreWarehouse1"
            }, {
                "description": "Store Warehouse2 [StoreWarehouse2]",
                "key": "StoreWarehouse2"
            }, {
                "description": "My Retail Store [MyRetailStore]",
                "key": "MyRetailStore"
            }],
            "disabled": "false",
            "id": "EditProductStoreFacility_facilityId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "facilityId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "3",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Sequence Num",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "sequenceNum",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "EditProductStoreFacility_sequenceNum",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "classString": "",
            "shortDateInput": "true",
            "ampmName": "",
            "className": "",
            "title": "From Date",
            "type": "DATE_TIME",
            "dateType": "date",
            "defaultDateTimeString": "2023-04-15",
            "timeDropdown": "time-dropdown",
            "alert": "false",
            "timeValues": "[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59]",
            "formName": "EditProductStoreFacility",
            "timeDropdownParamName": "fromDate_c_date",
            "timeMinutesName": "fromDate_c_minutes",
            "disabled": "false",
            "id": "EditProductStoreFacility_fromDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "10",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "10",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "fromDate_c_hour",
            "name": "fromDate_c_date",
            "style": "",
            "step": "1",
            "compositeType": "fromDate_c_compositeType"
        }, {
            "classString": "",
            "shortDateInput": "true",
            "ampmName": "",
            "className": "",
            "title": "Through Date",
            "type": "DATE_TIME",
            "dateType": "date",
            "defaultDateTimeString": "2023-04-15",
            "timeDropdown": "time-dropdown",
            "alert": "false",
            "timeValues": "[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59]",
            "formName": "EditProductStoreFacility",
            "timeDropdownParamName": "thruDate_c_date",
            "timeMinutesName": "thruDate_c_minutes",
            "disabled": "false",
            "id": "EditProductStoreFacility_thruDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "10",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "10",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "thruDate_c_hour",
            "name": "thruDate_c_date",
            "style": "",
            "step": "1",
            "compositeType": "thruDate_c_compositeType"
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "EditProductStoreFacility",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "EditProductStoreFacility_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Add",
            "event": "",
            "imgSrc": ""
        }],
        "target": "addProductStoreFacility"
    },
    {
        "columns": [{
            "name": "emailType",
            "title": "Email Type"
        }, {
            "name": "bodyScreenLocation",
            "title": "Body Screen Location"
        }, {
            "name": "xslfoAttachScreenLocation",
            "title": "Attachment Screen Location (XSL-FO)"
        }, {
            "name": "fromAddress",
            "title": "From Address"
        }, {
            "name": "ccAddress",
            "title": "Cc Address"
        }, {
            "name": "bccAddress",
            "title": "Bcc Address"
        }, {
            "name": "subject",
            "title": "Subject"
        }, {
            "name": "contentType",
            "title": "content Type"
        }, {
            "name": "submitButton",
            "title": "Update"
        }, {
            "name": "deleteLink",
            "title": "Delete"
        }],
        "formName": "UpdateProductStoreEmail",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "UpdateProductStoreEmail_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "emailType",
            "description": "",
            "style": "",
            "id": "UpdateProductStoreEmail_emailType",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Body Screen Location",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "bodyScreenLocation",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "UpdateProductStoreEmail_bodyScreenLocation",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Attachment Screen Location (XSL-FO)",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "xslfoAttachScreenLocation",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "UpdateProductStoreEmail_xslfoAttachScreenLocation",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "From Address",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "fromAddress",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "UpdateProductStoreEmail_fromAddress",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Cc Address",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "ccAddress",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "UpdateProductStoreEmail_ccAddress",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Bcc Address",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "bccAddress",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "UpdateProductStoreEmail_bccAddress",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Subject",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "subject",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "UpdateProductStoreEmail_subject",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "content Type",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "contentType",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "UpdateProductStoreEmail_contentType",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "UpdateProductStoreEmail",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "UpdateProductStoreEmail_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Update",
            "event": "",
            "imgSrc": ""
        }, {
            "image": "",
            "fieldHelpText": "",
            "alternate": "",
            "description": "Delete",
            "title": "Delete",
            "type": "HYPERLINK",
            "target": "removeProductStoreEmail",
            "name": "deleteLink",
            "width": "",
            "parameterList": [{
                "name": "productStoreId"
            }, {
                "name": "emailType"
            }],
            "style": "",
            "id": "UpdateProductStoreEmail_deleteLink",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "formData": {
                "formName": "removeProductStoreEmail",
                "formLocation": "component://kwikstore/widget/StoreForms.xml",
            },
            "event": "delete"
        }],
        "target": "updateProductStoreEmail"
    },
    {
        "formName": "CreateProductStoreEmail",
        "altTarget": [],
        "targets": {
            "createTarget": "createProductStoreEmail"
        },
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "CreateProductStoreEmail_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Email Type",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "CreateProductStoreEmail",
            "options": [{
                "description": "Party Registration Confirmation",
                "key": "PARTY_REGIS_CONFIRM"
            }, {
                "description": "Unsubscribe Contact List Notification",
                "key": "UNSUB_CONT_LIST_NOTI"
            }, {
                "description": "Registration",
                "key": "PRDS_CUST_REGISTER"
            }, {
                "description": "Update Personal Info Confirmation",
                "key": "UPD_PRSNL_INF_CNFRM"
            }, {
                "description": "Subscribe Contact List Notification",
                "key": "SUB_CONT_LIST_NOTI"
            }, {
                "description": "Confirmation",
                "key": "PRDS_ODR_CONFIRM"
            }, {
                "description": "Party Email Address Verification",
                "key": "PRDS_EMAIL_VERIFY"
            }, {
                "description": "Unsubscribe Contact List Verify",
                "key": "UNSUB_CONT_LIST_VERI"
            }, {
                "description": "Complete",
                "key": "PRDS_ODR_COMPLETE"
            }, {
                "description": "Party Invitation",
                "key": "PRDS_PARTYINV_EMAIL"
            }, {
                "description": "Contact List E-mail Template",
                "key": "CONT_EMAIL_TEMPLATE"
            }, {
                "description": "Back-Order",
                "key": "PRDS_ODR_BACKORDER"
            }, {
                "description": "Contact-Us Notification",
                "key": "CONT_NOTI_EMAIL"
            }, {
                "description": "Order Change",
                "key": "PRDS_ODR_CHANGE"
            }, {
                "description": "Account Activated Notification",
                "key": "PRDS_CUST_ACTIVATED"
            }, {
                "description": "Payment Retry",
                "key": "PRDS_ODR_PAYRETRY"
            }, {
                "description": "Return Accepted",
                "key": "PRDS_RTN_ACCEPT"
            }, {
                "description": "Return Completed",
                "key": "PRDS_RTN_COMPLETE"
            }, {
                "description": "Return Cancelled",
                "key": "PRDS_RTN_CANCEL"
            }, {
                "description": "Retrieve Password",
                "key": "PRDS_PWD_RETRIEVE"
            }, {
                "description": "Tell-A-Friend",
                "key": "PRDS_TELL_FRIEND"
            }, {
                "description": "Gift-Card Purchase",
                "key": "PRDS_GC_PURCHASE"
            }, {
                "description": "Gift-Card Reload",
                "key": "PRDS_GC_RELOAD"
            }, {
                "description": "Quote Created",
                "key": "PRDS_QUO_CREATED"
            }, {
                "description": "Quote Confirmation",
                "key": "PRDS_QUO_CONFIRM"
            }, {
                "description": "Shipment Complete",
                "key": "PRDS_ODR_SHIP_COMPLT"
            }],
            "disabled": "false",
            "id": "CreateProductStoreEmail_emailType",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "emailType",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Body Screen Location",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "bodyScreenLocation",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "CreateProductStoreEmail_bodyScreenLocation",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Attachment Screen Location (XSL-FO)",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "xslfoAttachScreenLocation",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "CreateProductStoreEmail_xslfoAttachScreenLocation",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "From Address",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "fromAddress",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "CreateProductStoreEmail_fromAddress",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Cc Address",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "ccAddress",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "CreateProductStoreEmail_ccAddress",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Bcc Address",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "bccAddress",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "CreateProductStoreEmail_bccAddress",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "Subject",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "subject",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "CreateProductStoreEmail_subject",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "60",
            "ajaxUrl": "",
            "maxlength": "250",
            "tabindex": "",
            "className": "",
            "title": "content Type",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "contentType",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "CreateProductStoreEmail_contentType",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "CreateProductStoreEmail",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "CreateProductStoreEmail_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Add",
            "event": "",
            "imgSrc": ""
        }],
        "target": "createProductStoreEmail"
    },
    {
        "columns": [{
            "name": "surveyApplTypeId",
            "title": "Type"
        }, {
            "name": "groupName",
            "title": "Name"
        }, {
            "name": "description",
            "title": "Surveys"
        }, {
            "name": "productId",
            "title": "Product"
        }, {
            "name": "productCategoryId",
            "title": "Category"
        }, {
            "name": "fromDate",
            "title": "From Date"
        }, {
            "name": "sequenceNum",
            "title": "Sequence Num"
        }, {
            "name": "deleteLink",
            "title": " "
        }],
        "formName": "EditProductStoreSurveys",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "EditProductStoreSurveys_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "conditionGroup": "",
            "name": "productStoreSurveyId",
            "action": "",
            "id": "EditProductStoreSurveys_productStoreSurveyId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "surveyApplTypeId",
            "description": "",
            "style": "",
            "id": "EditProductStoreSurveys_surveyApplTypeId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "groupName",
            "description": "",
            "style": "",
            "id": "EditProductStoreSurveys_groupName",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "image": "",
            "fieldHelpText": "",
            "alternate": "",
            "description": " []",
            "title": "Surveys",
            "type": "HYPERLINK",
            "target": "EditSurvey",
            "name": "description",
            "width": "",
            "parameterList": [{
                "name": "surveyId"
            }],
            "style": "",
            "id": "EditProductStoreSurveys_description",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "formData": {
                "formName": "EditSurvey",
                "formLocation": "component://kwikstore/widget/StoreForms.xml",
            },
            "event": "edit"
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "productId",
            "description": "",
            "style": "",
            "id": "EditProductStoreSurveys_productId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "productCategoryId",
            "description": "",
            "style": "",
            "id": "EditProductStoreSurveys_productCategoryId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "fromDate",
            "description": "",
            "style": "",
            "id": "EditProductStoreSurveys_fromDate",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "sequenceNum",
            "description": "",
            "style": "",
            "id": "EditProductStoreSurveys_sequenceNum",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "image": "",
            "width": "",
            "name": "deleteLink",
            "alternate": "",
            "description": "Remove",
            "parameterList": [{
                "name": "productStoreId"
            }, {
                "name": "productStoreSurveyId"
            }],
            "id": "EditProductStoreSurveys_deleteLink",
            "imageTitle": "",
            "parameterMap": {},
            "height": "",
            "target": "deleteProductStoreSurveyAppl"
        }],
        "target": ""
    },
    {
        "formName": "AddProductStoreSurveys",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "AddProductStoreSurveys_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Type",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "AddProductStoreSurveys",
            "options": [],
            "disabled": "false",
            "id": "AddProductStoreSurveys_surveyApplTypeId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "surveyApplTypeId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Group Name",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "groupName",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddProductStoreSurveys_groupName",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Surveys",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "AddProductStoreSurveys",
            "options": [],
            "disabled": "false",
            "id": "AddProductStoreSurveys_surveyId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "surveyId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "AddProductStoreSurveys",
                "id": "AddProductStoreSurveys_productId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupProduct",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "productId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "productId",
            "style": "",
            "id": "AddProductStoreSurveys_productId",
            "title": "Product ID",
            "type": "LOOKUP"
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "AddProductStoreSurveys",
                "id": "AddProductStoreSurveys_productCategoryId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupProductCategory",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "productCategoryId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "productCategoryId",
            "style": "",
            "id": "AddProductStoreSurveys_productCategoryId",
            "title": "Category ID",
            "type": "LOOKUP"
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "",
            "title": "${uiLabelMap.CommonFromDate",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-15%2008:03:56.236",
            "timeDropdown": "text",
            "alert": "false",
            "timeValues": "",
            "formName": "AddProductStoreSurveys",
            "timeDropdownParamName": "fromDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "AddProductStoreSurveys_fromDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "fromDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "classString": "",
            "shortDateInput": "false",
            "ampmName": "",
            "className": "",
            "title": "Through Date",
            "type": "DATE_TIME",
            "dateType": "timestamp",
            "defaultDateTimeString": "2023-04-15%2008:03:56.236",
            "timeDropdown": "text",
            "alert": "false",
            "timeValues": "",
            "formName": "AddProductStoreSurveys",
            "timeDropdownParamName": "thruDate",
            "timeMinutesName": "",
            "disabled": "false",
            "id": "AddProductStoreSurveys_thruDate",
            "event": "",
            "value": "",
            "pmSelected": "",
            "localizedInputTitle": "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask": "",
            "hour1": "0",
            "isTwelveHour": "false",
            "fieldHelpText": "",
            "hour2": "0",
            "maxlength": "30",
            "minutes": "0",
            "tabindex": "",
            "amSelected": "",
            "size": "25",
            "isXMLHttpRequest": "false",
            "localizedIconTitle": "View Calendar",
            "timeHourName": "",
            "name": "thruDate",
            "style": "",
            "step": "1",
            "compositeType": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Survey Template Path",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "surveyTemplate",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddProductStoreSurveys_surveyTemplate",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Result Template Path",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "resultTemplate",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddProductStoreSurveys_resultTemplate",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "": "",
            "fieldHelpText": "",
            "textSize": "25",
            "ajaxUrl": "",
            "maxlength": "",
            "tabindex": "",
            "className": "",
            "title": "Sequence Num",
            "type": "TEXT",
            "clientAutocomplete": "true",
            "ajaxEnabled": true,
            "readonly": false,
            "alert": "false",
            "name": "sequenceNum",
            "action": "",
            "style": "",
            "disabled": false,
            "id": "AddProductStoreSurveys_sequenceNum",
            "placeholder": "",
            "event": "",
            "value": "",
            "mask": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "AddProductStoreSurveys",
            "tabindex": "",
            "name": "submit",
            "className": "",
            "id": "AddProductStoreSurveys_submit",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Add",
            "event": "",
            "imgSrc": ""
        }],
        "target": "createProductStoreSurveyAppl"
    },
    {
        "columns": [{
            "name": "vendorPartyId",
            "title": "Vendor Party ID"
        }, {
            "name": "paymentMethodTypeId",
            "title": "Payment Method Type ID"
        }, {
            "name": "creditCardEnumId",
            "title": "Credit Card Enum ID"
        }, {
            "name": "submitButton",
            "title": "Delete"
        }],
        "formName": "ListProductStoreVendorPayments",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "ListProductStoreVendorPayments_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "vendorPartyId",
            "description": "",
            "style": "",
            "id": "ListProductStoreVendorPayments_vendorPartyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "paymentMethodTypeId",
            "description": "",
            "style": "",
            "id": "ListProductStoreVendorPayments_paymentMethodTypeId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "creditCardEnumId",
            "description": "",
            "style": "",
            "id": "ListProductStoreVendorPayments_creditCardEnumId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "ListProductStoreVendorPayments",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "ListProductStoreVendorPayments_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Delete",
            "event": "",
            "imgSrc": ""
        }],
        "target": "deleteProductStoreVendorPayment"
    },
    {
        "formName": "EditProductStoreVendorPayment",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "EditProductStoreVendorPayment_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStoreVendorPayment",
                "id": "EditProductStoreVendorPayment_vendorPartyId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupPartyName",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "vendorPartyId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "vendorPartyId",
            "style": "",
            "id": "EditProductStoreVendorPayment_vendorPartyId",
            "title": "Vendor Party ID",
            "type": "LOOKUP"
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Payment Method Type ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreVendorPayment",
            "options": [{
                "description": "Credit Card",
                "key": "CREDIT_CARD"
            }, {
                "description": "Gift Card",
                "key": "GIFT_CARD"
            }, {
                "description": "Gift Certificate",
                "key": "GIFT_CERTIFICATE"
            }, {
                "description": "Cash",
                "key": "CASH"
            }, {
                "description": "Electronic Funds Transfer",
                "key": "EFT_ACCOUNT"
            }, {
                "description": "Financial Account",
                "key": "FIN_ACCOUNT"
            }, {
                "description": "Personal Check",
                "key": "PERSONAL_CHECK"
            }, {
                "description": "Company Check",
                "key": "COMPANY_CHECK"
            }, {
                "description": "Certified Check",
                "key": "CERTIFIED_CHECK"
            }, {
                "description": "Money Order",
                "key": "MONEY_ORDER"
            }, {
                "description": "Company Account",
                "key": "COMPANY_ACCOUNT"
            }, {
                "description": "Billing Account",
                "key": "EXT_BILLACT"
            }, {
                "description": "Cash On Delivery",
                "key": "EXT_COD"
            }, {
                "description": "eBay",
                "key": "EXT_EBAY"
            }, {
                "description": "Offline Payment",
                "key": "EXT_OFFLINE"
            }, {
                "description": "PayPal",
                "key": "EXT_PAYPAL"
            }, {
                "description": "RBS WorldPay",
                "key": "EXT_WORLDPAY"
            }],
            "disabled": "false",
            "id": "EditProductStoreVendorPayment_paymentMethodTypeId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "paymentMethodTypeId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Credit Card Enum ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreVendorPayment",
            "options": [{
                "description": "Visa - Visa",
                "key": "CCT_VISA"
            }, {
                "description": "MasterCard - Master Card",
                "key": "CCT_MASTERCARD"
            }, {
                "description": "AmericanExpress - American Express",
                "key": "CCT_AMERICANEXPRESS"
            }, {
                "description": "DinersClub - Diners Club",
                "key": "CCT_DINERSCLUB"
            }, {
                "description": "Discover - Discover",
                "key": "CCT_DISCOVER"
            }, {
                "description": "EnRoute - EnRoute",
                "key": "CCT_ENROUTE"
            }, {
                "description": "CarteBlanche - Carte Blanche",
                "key": "CCT_CARTEBLANCHE"
            }, {
                "description": "JCB - JCB",
                "key": "CCT_JCB"
            }, {
                "description": "Solo - Solo",
                "key": "CCT_SOLO"
            }, {
                "description": "Switch - Switch",
                "key": "CCT_SWITCH"
            }, {
                "description": "VisaElectron - Visa Electron",
                "key": "CCT_VISAELECTRON"
            }, {
                "description": "UATP - Universal Air Travel Plan",
                "key": "CCT_UATP"
            }],
            "disabled": "false",
            "id": "EditProductStoreVendorPayment_creditCardEnumId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "creditCardEnumId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "EditProductStoreVendorPayment",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "EditProductStoreVendorPayment_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Add",
            "event": "",
            "imgSrc": ""
        }],
        "target": "createProductStoreVendorPayment"
    },
    {
        "columns": [{
            "name": "carrierPartyId",
            "title": "Carrier Party ID"
        }, {
            "name": "vendorPartyId",
            "title": "Vendor Party ID"
        }, {
            "name": "shipmentMethodTypeId",
            "title": "Shipment Method Type ID"
        }, {
            "name": "submitButton",
            "title": "Delete"
        }],
        "formName": "ListProductStoreVendorShipments",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "list",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "ListProductStoreVendorShipments_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "carrierPartyId",
            "description": "",
            "style": "",
            "id": "ListProductStoreVendorShipments_carrierPartyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "vendorPartyId",
            "description": "",
            "style": "",
            "id": "ListProductStoreVendorShipments_vendorPartyId",
            "title": "",
            "type": "DISPLAY",
            "imageLocation": ""
        }, {
            "fieldHelpText": "",
            "ajaxEnabled": false,
            "size": 0,
            "name": "shipmentMethodTypeId",
            "description": "",
            "style": "",
            "id": "ListProductStoreVendorShipments_shipmentMethodTypeId",
            "title": "",
            "type": "DISPLAY_ENTITY",
            "imageLocation": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "ListProductStoreVendorShipments",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "ListProductStoreVendorShipments_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Delete",
            "event": "",
            "imgSrc": ""
        }],
        "target": "deleteProductStoreVendorShipment"
    },
    {
        "formName": "EditProductStoreVendorShipment",
        "altTarget": [],
        "formLocation": "component://kwikstore/widget/StoreForms.xml",
        "type": "single",
        "fields": [{
            "conditionGroup": "",
            "name": "productStoreId",
            "action": "",
            "id": "EditProductStoreVendorShipment_productStoreId",
            "type": "HIDDEN",
            "event": "",
            "value": ""
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStoreVendorShipment",
                "id": "EditProductStoreVendorShipment_carrierPartyId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupPartyName",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "carrierPartyId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "carrierPartyId",
            "style": "",
            "id": "EditProductStoreVendorShipment_carrierPartyId",
            "title": "Carrier Party ID",
            "type": "LOOKUP"
        }, {
            "fieldHelpText": "",
            "lookupOptions": {
                "ajaxUrl": "",
                "fadeBackground": "true",
                "conditionGroup": "",
                "targetParameterList": [""],
                "className": "",
                "type": "LOOKUP",
                "presentation": "layer",
                "initiallyCollapsed": "false",
                "ajaxEnabled": "true",
                "showDescription": "true",
                "delegatorName": "",
                "readonly": "false",
                "alert": "false",
                "formName": "EditProductStoreVendorShipment",
                "id": "EditProductStoreVendorShipment_vendorPartyId",
                "event": "",
                "value": "",
                "fieldFormName": "LookupPartyName",
                "maxlength": "",
                "autocomplete": "",
                "clearText": "Clear",
                "tabindex": "",
                "size": "25",
                "name": "vendorPartyId",
                "descriptionFieldName": "",
                "position": "topleft",
                "imgSrc": ""
            },
            "name": "vendorPartyId",
            "style": "",
            "id": "EditProductStoreVendorShipment_vendorPartyId",
            "title": "Vendor Party ID",
            "type": "LOOKUP"
        }, {
            "fieldName": "",
            "firstInList": "",
            "partialChars": "",
            "conditionGroup": "",
            "otherFieldName": "",
            "className": "",
            "title": "Shipment Method Type ID",
            "type": "DROP_DOWN",
            "frequency": "",
            "minChars": "",
            "allowEmpty": "",
            "autoSelect": "",
            "ajaxEnabled": "false",
            "noCurrentSelectedKey": "",
            "ajaxOptions": "",
            "alert": "false",
            "otherFieldSize": "0",
            "ignoreCase": "",
            "formName": "EditProductStoreVendorShipment",
            "options": [{
                "description": "Standard",
                "key": "STANDARD"
            }, {
                "description": "Express",
                "key": "EXPRESS"
            }, {
                "description": "Ground",
                "key": "GROUND"
            }, {
                "description": "Air",
                "key": "AIR"
            }, {
                "description": "Guaranteed Next Day",
                "key": "NEXT_DAY"
            }, {
                "description": "Local Delivery",
                "key": "LOCAL_DELIVERY"
            }, {
                "description": "No Shipping",
                "key": "NO_SHIPPING"
            }, {
                "description": "Next Morning",
                "key": "NEXT_AM"
            }, {
                "description": "Next Afternoon",
                "key": "NEXT_PM"
            }, {
                "description": "Same Day",
                "key": "SAME_DAY"
            }, {
                "description": "Third Day",
                "key": "THIRD_DAY"
            }, {
                "description": "International Express",
                "key": "INT_EXPRESS"
            }, {
                "description": "Priority Overnight",
                "key": "PR_OVERNIGHT"
            }, {
                "description": "Standard Overnight",
                "key": "ST_OVERNIGHT"
            }, {
                "description": "First Overnight",
                "key": "FI_OVERNIGHT"
            }, {
                "description": "Second Day",
                "key": "SECOND_DAY"
            }, {
                "description": "Express Saver",
                "key": "EXPRESS_SAVER"
            }, {
                "description": "International Priority",
                "key": "INTERNAT_PRI"
            }, {
                "description": "International Economy",
                "key": "INTERNAT_ECON"
            }, {
                "description": "International First",
                "key": "INTERNAT_FI"
            }, {
                "description": "1Day Freight",
                "key": "FIRST_DAY_FR"
            }, {
                "description": "2Day Freight",
                "key": "SECOND_DAY_FR"
            }, {
                "description": "3Day Freight",
                "key": "THIRD_DAY_FR"
            }, {
                "description": "Ground Home Delivery",
                "key": "GROUND_HOME"
            }, {
                "description": "International Economy Freight",
                "key": "INTERNAT_ECON_FR"
            }, {
                "description": "International Priority Freight",
                "key": "INTERNAT_PRI_FR"
            }, {
                "description": "2Day AM",
                "key": "SECOND_DAY_AM"
            }, {
                "description": "Europe First Priority",
                "key": "EUROPE_FI_PRIORITY"
            }, {
                "description": "Smart Post",
                "key": "SMART_POST"
            }, {
                "description": "Fedex National Freight",
                "key": "FEDEX_NATIONAL_FR"
            }, {
                "description": "Fedex International Ground ",
                "key": "FEDEX_INT_GROUND"
            }, {
                "description": "Fedex Freight",
                "key": "FEDEX_FREIGHT"
            }, {
                "description": "Three-Day Select",
                "key": "THIRD_DAY_AIR_SEL"
            }, {
                "description": "Second Day Air",
                "key": "SECOND_DAY_AIR"
            }, {
                "description": "Second Day Air Early A.M.  ",
                "key": "SECOND_DAY_AIR_AM"
            }, {
                "description": "Next Day Air Saver",
                "key": "NEXT_DAY_AIR_SA"
            }, {
                "description": "Next Day Air",
                "key": "NEXT_DAY_AIR"
            }, {
                "description": "Next Day Air Early A.M.",
                "key": "NEXT_DAY_AIR_AM"
            }, {
                "description": "Worldwide ExpressSM",
                "key": "WORLDWIDE_EXPRESS"
            }, {
                "description": "Worldwide Express Plus",
                "key": "WORLDWIDE_EXPR_PLUS"
            }, {
                "description": "Worldwide ExpeditedSM",
                "key": "WORLDWIDE_EXPEDITED"
            }, {
                "description": "Saver",
                "key": "SAVER"
            }, {
                "description": "First Class",
                "key": "FIRST_CLASS"
            }, {
                "description": "First Class International",
                "key": "FC_INTERNATIONAL"
            }, {
                "description": "Priority",
                "key": "PRIORITY"
            }, {
                "description": "Priority International",
                "key": "PR_INTERNATIONAL"
            }, {
                "description": "Express International",
                "key": "EXP_INTERNATIONAL"
            }, {
                "description": "Media Mail",
                "key": "MEDIA_MAIL"
            }, {
                "description": "Standard Post",
                "key": "STANDARD_POST"
            }, {
                "description": "Library",
                "key": "LIBRARY"
            }, {
                "description": "Express Saturday",
                "key": "EXP_SATURDAY"
            }, {
                "description": "Express 10.30 AM",
                "key": "EXP_10_30_AM"
            }],
            "disabled": "false",
            "id": "EditProductStoreVendorShipment_shipmentMethodTypeId",
            "event": "",
            "otherValue": "",
            "fullSearch": "",
            "fieldHelpText": "",
            "dDFCurrent": "selected",
            "tabindex": "",
            "multiple": "",
            "partialSearch": "",
            "size": "1",
            "name": "shipmentMethodTypeId",
            "style": "",
            "explicitDescription": "",
            "choices": "",
            "currentValue": ""
        }, {
            "buttonType": "button",
            "alert": "false",
            "formName": "EditProductStoreVendorShipment",
            "tabindex": "",
            "name": "submitButton",
            "className": "smallSubmit",
            "id": "EditProductStoreVendorShipment_submitButton",
            "confirmation": "",
            "type": "SUBMIT",
            "title": "Add",
            "event": "",
            "imgSrc": ""
        }],
        "target": "createProductStoreVendorShipment"
    }
]